import {
  CertificationStatusDto,
  CommissionCandidateRoleDto,
  DevelopmentCycleCampaignStatusDto,
  ExamDayStatusDto,
  ExamStageStatusDto,
  IndividualExamStatusDto,
  NewsCategoryDto,
  NewsStatusDto,
  PracticalExamAttemptStatusDto,
  ResourceTypeDto,
  SurveyAssignmentStatusDto,
} from '@/api/generated';

export type AdminPanelTranslation = {
  certifications: {
    adminInstructions: {
      closeButton: string;
      drawerTitle: string;
      sectionTitles: {
        adminSteps: string;
        employeeView: string;
        purpose: string;
        rules: string;
        transition: string;
      };
      stages: {
        developmentCenter: StageInstructionBody;
        exam: StageInstructionBody;
        plan: StageInstructionBody;
        survey: StageInstructionBody;
        test: StageInstructionBody;
      };
      stepPrefix: string;
    };
    assignSurveyDialog: {
      assignError: string;
      assignExistingTab: string;
      assignSuccess: string;
      chooseFileButton: string;
      clearDeadline: string;
      closeButton: string;
      createAssignButton: string;
      createError: string;
      createNewTab: string;
      creatingButton: string;
      currentlyAssigned: string;
      deadlineHelp: string;
      deadlineLabel: string;
      deadlinePastWarning: string;
      deadlineValidation: string;
      detachButton: string;
      detachError: string;
      detachSuccess: string;
      dragDropText: string;
      fileLabel: string;
      fileRequired: string;
      nameMaxLength: string;
      nameRequired: string;
      noSurveysFound: string;
      orSelectDifferent: string;
      searchButton: string;
      searchPlaceholder: string;
      surveyNameLabel: string;
      title: string;
      validationErrorsTitle: string;
      validationErrorsToast: string;
    };
    deleteDialog: {
      cancelButton: string;
      deleteButton: string;
      deleteError: string;
      deleteSuccess: string;
      deletingButton: string;
      messageEnd: string;
      messageStart: string;
      title: string;
    };
    detail: {
      backButton: string;
      detachError: string;
      detachSuccess: string;
      editButton: string;
      flowTitle: string;
      label: string;
      loading: string;
      metaCreated: string;
      metaDeadline: string;
      metaUpdated: string;
      notFound: string;
      participants: {
        addedAt: string;
        attempts_few: string;
        attempts_many: string;
        attempts_one: string;
        attempts_other: string;
        bestScore: string;
        commonFilters: {
          clearAll: string;
          position: string;
          positionPlaceholder: string;
          search: string;
          searchPlaceholder: string;
          sort: string;
          sortOptions: {
            bestTestScoreDesc: string;
            examAttemptsDesc: string;
            lastNameAsc: string;
            testAttemptsDesc: string;
          };
          stageFiltersButton: string;
          title: string;
        };
        drill: {
          actions: string;
          assigned: string;
          assignedMetaNo: string;
          assignedMetaYes: string;
          attempts: string;
          attemptsMeta_few: string;
          attemptsMeta_many: string;
          attemptsMeta_one: string;
          attemptsMeta_other: string;
          bestScore: string;
          collapse: string;
          comment: string;
          comments: string;
          commission: string;
          commissionRole: {
            CHAIRMAN: string;
            HRBP: string;
          };
          completedAt: string;
          correctOfTotal: string;
          date: string;
          daysTitle: string;
          examTitle: string;
          expand: string;
          location: string;
          no: string;
          noDays: string;
          noExam: string;
          noSurvey: string;
          noTerms: string;
          noTest: string;
          notPassed: string;
          overall: string;
          passed: string;
          questions: string;
          score: string;
          scoreMeta: string;
          startedAt: string;
          status: string;
          surveyTitle: string;
          term: string;
          termsTitle: string;
          testTitle: string;
          time: string;
          viewAnswers: string;
          viewExam: string;
          yes: string;
        };
        email: string;
        error: string;
        filters: {
          clear: string;
          csvHint: string;
          employeeSection: string;
          passed: string;
          positionCodes: string;
          regionCodes: string;
          scoreMax: string;
          scoreMin: string;
          status: string;
          surveyAssigned: string;
          title: string;
          tri: {
            any: string;
            no: string;
            yes: string;
          };
        };
        filterStagesPlaceholder: string;
        flashcardDownload: {
          cancel: string;
          confirm: string;
          description: string;
          reasons: {
            CERTIFICATION_PROCESS: string;
            DEVELOPMENT_CONVERSATION: string;
            HR_REQUEST: string;
            OTHER: string;
          };
          reasonTextLabel: string;
          title: string;
        };
        flashcardHistory: {
          empty: string;
          reasons: {
            CERTIFICATION_PROCESS: string;
            DEVELOPMENT_CONVERSATION: string;
            HR_REQUEST: string;
            OTHER: string;
          };
          summary: string;
          title: string;
          unknownUser: string;
        };
        loading: string;
        name: string;
        noData: string;
        noScore: string;
        openButton: string;
        practicalExamStatistics: {
          charts: {
            perAreaTitle: string;
            perRegionTitle: string;
            perStoreTitle: string;
          };
          download: string;
          emptyFilters: string;
          error: string;
          kpi: {
            exams: string;
            participants: string;
          };
          noData: string;
          perPersonTitle: string;
          series: {
            avgScore: string;
            passRate: string;
          };
          table: {
            areaColumn: string;
            attemptNumber: string;
            chairman: string;
            duration: string;
            examDate: string;
            no: string;
            participant: string;
            passed: string;
            region: string;
            result: string;
            sap: string;
            status: string;
            store: string;
            yes: string;
          };
          title: string;
          tooltip: {
            exams: string;
            gradedExams: string;
            participants: string;
          };
        };
        rowsPerPage: string;
        searchPlaceholder: string;
        stageFilters: {
          activeCount_few: string;
          activeCount_many: string;
          activeCount_one: string;
          activeCount_other: string;
          all: string;
          any: string;
          attempts: string;
          close: string;
          commission: string;
          commissionPlaceholder: string;
          drawerTitle: string;
          exam: {
            hint: string;
            title: string;
          };
          examDay: string;
          loading: string;
          location: string;
          locationPlaceholder: string;
          max: string;
          min: string;
          no: string;
          passed: string;
          status: string;
          survey: {
            hint: string;
            title: string;
          };
          surveyAssigned: string;
          surveyNotification: string;
          term: string;
          test: {
            hint: string;
            title: string;
          };
          testScore: string;
          yes: string;
        };
        stages: string;
        status: {
          ABSENT: string;
          CANCELLED: string;
          COMPLETED: string;
          FAILED: string;
          IN_PROGRESS: string;
          NOT_STARTED: string;
        };
        surveyNotAssigned: string;
        surveyStatus: {
          COMPLETED: string;
          IN_PROGRESS: string;
          NOT_STARTED: string;
        };
        table: {
          exam: string;
          flashcard: string;
          flashcardHistoryTooltip: string;
          flashcardTooltip: string;
          name: string;
          position: string;
          region: string;
          survey: string;
          test: string;
        };
        teaserSubtitle: string;
        testStatistics: {
          charts: {
            distributionTitle: string;
            perPositionTitle: string;
            perQuestionTitle: string;
            perRegionTitle: string;
            perSectionTitle: string;
          };
          detailsTitle: string;
          download: string;
          emptyFilters: string;
          error: string;
          kpi: {
            executions: string;
            participants: string;
          };
          legendNoAnswer: string;
          noData: string;
          noValue: string;
          questionShort: string;
          table: {
            answerKey: string;
            answers: string;
            avgDuration: string;
            choices: string;
            content: string;
            correctRate: string;
            number: string;
            section: string;
          };
          title: string;
          tooltip: {
            attempts: string;
            avgBestScore: string;
            avgCorrectCaption: string;
            avgDuration: string;
            correctOf: string;
            noAnswer: string;
            noAttempts: string;
            noSection: string;
            participants: string;
            question: string;
            questionsInSection: string;
            seconds: string;
          };
        };
        title: string;
        titleTooltip: string;
      };
      stageStatusChange: {
        activateButton: string;
        activateSuccess: string;
        cancelButton: string;
        cancelSuccess: string;
        completeButton: string;
        completeSuccess: string;
        error: string;
        label: string;
        revertButton: string;
        revertSuccess: string;
        testClosureConfirm: {
          cancelAction: string;
          confirmAction: string;
          confirmCancel: string;
          confirmComplete: string;
          titleCancel: string;
          titleComplete: string;
        };
      };
      statusChange: {
        activateButton: string;
        activateSuccess: string;
        cancelButton: string;
        cancelSuccess: string;
        completeButton: string;
        completeSuccess: string;
        error: string;
        label: string;
      };
      statusWarningsDialog: {
        activateButton: string;
        closeButton: string;
        subtitle: string;
        title: string;
      };
      steps: {
        developmentCenter: {
          description: string;
          initializeButton: string;
          manageHint: string;
          openStageButton: string;
          optionalHint: string;
          reportsNotShared: string;
          reportsScheduledFrom: string;
          reportsSharedSince: string;
          resultsSummary: string;
          stageActive: string;
          stageCreatedError: string;
          stageCreatedSuccess: string;
          stageNotInitialized: string;
          title: string;
        };
        developmentPlan: {
          campaignNoName: string;
          campaignStatus: Record<DevelopmentCycleCampaignStatusDto, string>;
          coveredLabel: string;
          description: string;
          directionLabel: string;
          directionMissing: string;
          loadError: string;
          loadErrorHint: string;
          noPermission: string;
          notStarted: string;
          notStartedHint: string;
          notStartedNoPermissionHint: string;
          openCampaignsButton: string;
          openMembersButton: string;
          retryButton: string;
          tasksStartLabel: string;
          title: string;
          windowLabel: string;
        };
        knowledgeTest: {
          attachButton: string;
          attachDialog: {
            attachButton: string;
            attachError: string;
            attachingButton: string;
            attachSuccess: string;
            cancelButton: string;
            loading: string;
            noPools: string;
            questionCount: string;
            searchPlaceholder: string;
            title: string;
          };
          browseButton: string;
          config: {
            backNav: string;
            notConfigured: string;
            pass: string;
            questions: string;
          };
          description: string;
          detachButton: string;
          detachError: string;
          detachSuccess: string;
          emptyPools: string;
          initializeButton: string;
          manageParticipantsAndTerms: string;
          openConfig: string;
          poolsTitle: string;
          stageCreatedError: string;
          stageCreatedSuccess: string;
          stageNamePlaceholder: string;
          stageNotInitialized: string;
          stageParticipants: {
            addButton: string;
            addByEmployee: string;
            addByPosition: string;
            addBySap: string;
            addedHeader: string;
            addError: string;
            addPositionButton: string;
            addPositionCodesHelper: string;
            addPositionError: string;
            addPositionInvalidFormat: string;
            addPositionPlaceholder: string;
            addSapButton: string;
            addSapError: string;
            addSapHelper: string;
            addSapInvalidFormat: string;
            addSapPlaceholder: string;
            addSelectedButton: string;
            addSuccess: string;
            allInStageEmpty: string;
            emailHeader: string;
            filtersClear: string;
            filterStatus: string;
            filtersToggle: string;
            filterTerms: string;
            more: string;
            nameHeader: string;
            noParticipants: string;
            noParticipantsHint: string;
            noTerms: string;
            removeError: string;
            removeSuccess: string;
            removeTooltip: string;
            searchParticipantsPlaceholder: string;
            searchPlaceholder: string;
            showing: string;
            showLess: string;
            status: {
              ASSIGNED: string;
              EXPIRED: string;
              FAILED: string;
              PASSED: string;
              STARTED: string;
            };
            termHistoryHeader: string;
            title: string;
          };
          testTerms: {
            cancelButton: string;
            cancelledLabel: string;
            completeButton: string;
            completedLabel: string;
            createDialog: {
              cancelButton: string;
              createButton: string;
              createError: string;
              createSuccess: string;
              creatingButton: string;
              endHint: string;
              endLabel: string;
              nameLabel: string;
              nameMaxLength: string;
              namePlaceholder: string;
              nameRequired: string;
              startLabel: string;
              startRequired: string;
              subtitle: string;
              title: string;
            };
            createFirstButton: string;
            editDialog: {
              cancelButton: string;
              endLabel: string;
              hint: string;
              nameLabel: string;
              namePlaceholder: string;
              nameRequired: string;
              saveButton: string;
              savingButton: string;
              startLabel: string;
              startLockedHelper: string;
              subtitle: string;
              title: string;
              updateError: string;
              updateSuccess: string;
            };
            extendTimeButton: string;
            extendTimeConfirm: string;
            extendTimeError: string;
            extendTimeHint: string;
            extendTimeLabel: string;
            extendTimeSuccess: string;
            extendTimeTitle: string;
            hideParticipants: string;
            inProgressLabel: string;
            newButton: string;
            newLabel: string;
            noTermsDescription: string;
            noTermsTitle: string;
            participants: string;
            participantsDialog: {
              activityReportError: string;
              activityReportTooltip: string;
              addButton: string;
              addError: string;
              addSelectedButton: string;
              addSuccess: string;
              allInTermEmpty: string;
              closeButton: string;
              emailHeader: string;
              noParticipants: string;
              noParticipantsHint: string;
              participantHeader: string;
              removeError: string;
              removeSuccess: string;
              removeTooltip: string;
              searchByNameEmail: string;
              searchPlaceholder: string;
              selectLabel: string;
              statusAssigned: string;
              statusExpired: string;
              statusFailed: string;
              statusHeader: string;
              statusPassed: string;
              statusStarted: string;
              subtitle: string;
              title: string;
              viewResultsTooltip: string;
            };
            resultsDialog: {
              closeButton: string;
              correctAnswerHeader: string;
              correctLabel: string;
              executionStatus: {
                COMPLETED_FAILED: string;
                COMPLETED_PASSED: string;
                EXPIRED: string;
                IN_PROGRESS: string;
                NOT_STARTED: string;
              };
              filterAll: string;
              filterCorrect: string;
              filterIncorrect: string;
              incorrectLabel: string;
              noAnswerLabel: string;
              questionHeader: string;
              sectionHeader: string;
              unansweredLabel: string;
              yourAnswerHeader: string;
            };
            resultsListDialog: {
              closeButton: string;
              correctHeader: string;
              noResults: string;
              noResultsHint: string;
              participantHeader: string;
              scoreHeader: string;
              searchPlaceholder: string;
              statusHeader: string;
              subtitle: string;
              title: string;
              viewDetailTooltip: string;
            };
            revertButton: string;
            revertSuccess: string;
            showParticipants: string;
            startBlockedReason: string;
            startBlockedStageInactiveReason: string;
            startButton: string;
            startCertificationDraftInfo: string;
            startExtensionInfo: string;
            startInFutureInfo: string;
            startInPastInfo: string;
            startStageDraftInfo: string;
            title: string;
            updatedAt: string;
            updateError: string;
            updateSuccess: string;
            viewParticipantsTooltip: string;
            viewResultsTooltip: string;
          };
          title: string;
          uploadButton: string;
          uploadToPoolButton: string;
        };
        practicalTest: {
          comingSoon: string;
          config: { notConfigured: string };
          description: string;
          examDays: string;
          initializeButton: string;
          openConfig: string;
          stageCreatedError: string;
          stageCreatedSuccess: string;
          stageNamePlaceholder: string;
          stageNotInitialized: string;
          title: string;
        };
        selfAssessment: { description: string; title: string };
      };
    };
    developmentCenterStage: {
      backButton: string;
      card: { edit: string; hide: string };
      certificationsTitle: string;
      coverage: { percent: string; ratio: string };
      expectedScore: {
        error: string;
        fieldLabel: string;
        hint: string;
        label: string;
        notSet: string;
        placeholder: string;
        save: string;
        saved: string;
        scaleUnavailable: string;
        valueWithScale: string;
      };
      importSummary: {
        allCovered: string;
        assigned: string;
        close: string;
        copied: string;
        copyFailed: string;
        copyList: string;
        missing: string;
        missingHint: string;
        rejected: string;
        rejectedHint: string;
        showErrors: string;
        subtitle: string;
        title: string;
        unknownPerson: string;
      };
      label: string;
      lastImport: {
        empty: string;
        label: string;
        meta: string;
        problems: string;
        resolve: string;
        success: string;
        unknownAuthor: string;
        unknownFile: string;
      };
      loading: string;
      notFound: string;
      notInitialized: string;
      participants: {
        columns: {
          feedback: string;
          name: string;
          position: string;
          region: string;
          removeFromStage: string;
          report: string;
          results: string;
          sapNumber: string;
        };
        downloadReport: string;
        empty: string;
        emptyStage: string;
        enrolAll: {
          action: string;
          cancel: string;
          confirm: string;
          description: string;
          result: string;
          title: string;
        };
        feedback: {
          clearConfirm: {
            cancel: string;
            confirm: string;
            description: string;
            title: string;
          };
          coverageEmpty: string;
          coverageStatus: string;
          coverageTitle: string;
          source: { IMPORT: string; MANUAL: string };
          statusCompleted: string;
          statusMissing: string;
          toggleAriaLabel: string;
          tooltipAuthor: string;
          tooltipDate: string;
          tooltipSource: string;
          unknownAuthor: string;
        };
        feedbackImport: {
          acceptedFormats: string;
          action: string;
          cancel: string;
          columnsHint: string;
          columnsTitle: string;
          dropzoneLabel: string;
          form: { resetButton: string; uploadButton: string };
          submit: string;
          subtitle: string;
          summary: {
            allSaved: string;
            close: string;
            problemRow: string;
            problemRowWithoutSap: string;
            problems: string;
            problemsHint: string;
            rowsRead: string;
            setNo: string;
            setYes: string;
            skipped: string;
            subtitle: string;
            title: string;
            unchanged: string;
          };
          title: string;
          uploadError: string;
        };
        filters: {
          ALL: string;
          label: string;
          WITHOUT_FEEDBACK: string;
          WITHOUT_REPORT: string;
          WITHOUT_RESULTS: string;
        };
        foundCount_few: string;
        foundCount_many: string;
        foundCount_one: string;
        foundCount_other: string;
        notAssignedHint: string;
        removeFromStage: {
          action: string;
          cancel: string;
          confirm: string;
          description: string;
          title: string;
        };
        searchPlaceholder: string;
        statusMissing: string;
        statusPresent: string;
        totalPill: string;
        unknownPerson: string;
        withReportPill: string;
        withResultsPill: string;
      };
      reports: {
        acceptedFormats: string;
        coverageTitle: string;
        dropzoneLabel: string;
        form: { resetButton: string; uploadButton: string };
        overwriteWarning: string;
        overwriteWarningTitle: string;
        replaceLabel: string;
        showWithoutReport: string;
        statusComplete: string;
        statusEmpty: string;
        statusNone: string;
        statusPartial: string;
        statusScheduled: string;
        statusShared: string;
        transferProgress: string;
        unpackingLabel: string;
        unpackingProgress: string;
        unpackingStarted: string;
        uploadButton: string;
        uploadError: string;
        uploadHint: string;
        uploadLabel: string;
        visibilityLabel: string;
        visibleFromClear: string;
        visibleFromCleared: string;
        visibleFromError: string;
        visibleFromField: string;
        visibleFromHint: string;
        visibleFromSave: string;
        visibleFromSaved: string;
      };
      results: {
        acceptedFormats: string;
        coverageTitle: string;
        downloadFile: string;
        dropzoneLabel: string;
        expectedScoreLabel: string;
        expectedScoreMeta: string;
        expectedScorePlaceholder: string;
        expectedScoreValueWithScale: string;
        form: { resetButton: string; uploadButton: string };
        historyLabel: string;
        importMeta: string;
        replaceLabel: string;
        scaleUnavailable: string;
        showWithoutResults: string;
        statusComplete: string;
        statusEmpty: string;
        statusNoneCovered: string;
        statusPartial: string;
        unknownAuthor: string;
        unknownFile: string;
        uploadButton: string;
        uploadError: string;
        uploadHint: string;
        uploadLabel: string;
        uploadStarted: string;
      };
      subtitle: string;
      tabs: {
        participants: string;
        reports: string;
        results: string;
      };
      title: string;
      upload: { collapse: string; expand: string };
    };
    examStageConfig: {
      bar: {
        attemptsUnit: string;
        passPrefix: string;
        questionsUnit: string;
      };
      cancelButton: string;
      configureButton: string;
      confirmDialog: {
        cancel: string;
        confirm: string;
        title: string;
      };
      editButton: string;
      fields: {
        maxAttempts: string;
        maxQuestions: string;
        minQuestions: string;
        noLimit: string;
        ofQuestions: string;
        questionsCount: string;
        questionsShort: string;
        requiredToPass: string;
        timeLimitMinutes: string;
      };
      notConfigured: string;
      saveButton: string;
      validation: {
        maxAttempts: string;
        maxQuestions: string;
        minQuestions: string;
        questionsCount: string;
        requiredToPass: string;
      };
    };
    examStageDetail: {
      commissionMemberSearch: {
        extraMemberBadge: string;
        loading: string;
        noOptions: string;
      };
      createExamDay: {
        cancelButton: string;
        createButton: string;
        fields: {
          chairman: string;
          date: string;
          hrbp: string;
          location: string;
        };
        title: string;
      };
      examDayDetail: {
        addParticipant: string;
        addParticipantDialog: {
          addedEmpty: string;
          addedTitle: string;
          addTooltip: string;
          allRegions: string;
          availableTitle: string;
          clearFilters: string;
          close: string;
          empty: string;
          noResults: string;
          regionLabel: string;
          searchPlaceholder: string;
          title: string;
        };
        cancelDay: string;
        cancelExam: string;
        chairman: string;
        columns: {
          actions: string;
          examStatus: string;
          name: string;
          result: string;
        };
        completeDay: string;
        dayStatus: Record<ExamDayStatusDto, string>;
        examsTitle: string;
        generateExams: string;
        noExam: string;
        noParticipants: string;
        participants: string;
        removeParticipant: string;
        startDay: string;
      };
      examDays: {
        addButton: string;
        backToList: string;
        cancelButton: string;
        chairman: string;
        completeButton: string;
        dayStatus: Record<ExamDayStatusDto, string>;
        empty: string;
        filters: {
          clear: string;
          commissionMember: string;
          dateFrom: string;
          dateTo: string;
          noResults: string;
          searchPlaceholder: string;
          toggle: string;
        };
        participantsCount: string;
        startBlockedStageInactiveReason: string;
        startButton: string;
        title: string;
        updateError: string;
      };
      examQuestion: {
        answerKeyLabel: string;
        chairmanComment: string;
        commentPlaceholder: string;
        hrbpComment: string;
        questionLabel: string;
        reportAreaLabel: string;
        reportLabel: string;
        reportShareNotSharedLabel: string;
        reportShareShareButton: string;
        reportShareSharedLabel: string;
        reportShareUnshareButton: string;
        reportTag: string;
        subquestionLabel: string;
        subquestionsTitle: string;
        verdictFail: string;
        verdictPass: string;
        verdictRejected: string;
      };
      extraCommissionMembers: {
        addButton: string;
        addedBy: string;
        columns: {
          actions: string;
          added: string;
          name: string;
          roles: string;
          sapNumber: string;
        };
        description: string;
        dialog: {
          add: string;
          addTitle: string;
          alreadyOnList: string;
          cancel: string;
          editTitle: string;
          loading: string;
          noOptions: string;
          personLabel: string;
          rolesLabel: string;
          rolesRequired: string;
          save: string;
          saveError: string;
          searchPlaceholder: string;
        };
        editTooltip: string;
        empty: string;
        loadError: string;
        removeDialog: {
          cancel: string;
          confirm: string;
          conflict: string;
          description: string;
          error: string;
          title: string;
        };
        removeTooltip: string;
        roles: Record<CommissionCandidateRoleDto, string>;
        title: string;
      };
      individualExam: {
        cancelButton: string;
        carriedOver: {
          close: string;
          modalTitle: string;
          previewSourceTooltip: string;
          question: string;
          report: string;
          subtitle: string;
          title: string;
        };
        chairmanComment: string;
        changelog: string;
        createdAt: string;
        dayNotStarted: string;
        dayNotStartedDialogCancel: string;
        dayNotStartedDialogConfirm: string;
        dayNotStartedDialogMessage: string;
        dayNotStartedDialogTitle: string;
        editModeOff: string;
        editModeOn: string;
        examStatus: Record<IndividualExamStatusDto, string>;
        failed: string;
        finishButton: string;
        finishedAtLabel: string;
        generalComment: string;
        generalCommentPlaceholder: string;
        generalCommentVisibilityNotice: string;
        hrbpComment: string;
        infoAssignedQuestions: string;
        infoMinQuestions: string;
        infoQuestionsShort: string;
        infoRequiredToPass: string;
        infoTimeLimit: string;
        minRequired: string;
        notPassing: string;
        passed: string;
        passing: string;
        progress: string;
        questionsTitle: string;
        result: string;
        resultFailed: string;
        resultPassed: string;
        stage2AttemptsCount_few: string;
        stage2AttemptsCount_many: string;
        stage2AttemptsCount_one: string;
        stage2AttemptsCount_other: string;
        stage2Failed: string;
        stage2NotAvailable: string;
        stage2NoTerms: string;
        stage2Passed: string;
        stage2Result: string;
        stage2Status: {
          ABSENT: string;
          COMPLETED: string;
          FAILED: string;
          IN_PROGRESS: string;
          NOT_STARTED: string;
        };
        stage2TermsListTitle: string;
        stage2ViewAttemptsTooltip: string;
        stage2ViewTooltip: string;
        startButton: string;
        startedAtLabel: string;
        total: string;
      };
      label: string;
      loading: string;
      notInitialized: string;
      participants: {
        add: string;
        addButton: string;
        addByEmployee: string;
        addByPosition: string;
        addBySap: string;
        addedNoneNotFound: string;
        addedNoneTestNotPassed: string;
        addedSummaryWithSkipped: string;
        addedSummaryWithSkippedSap: string;
        addFromCertification: string;
        addPositionButton: string;
        addPositionCodesHelper: string;
        addPositionError: string;
        addPositionInvalidFormat: string;
        addPositionPlaceholder: string;
        addSapButton: string;
        addSapError: string;
        addSapHelper: string;
        addSapInvalidFormat: string;
        addSapPlaceholder: string;
        addSelectedButton: string;
        addSuccess: string;
        columns: {
          actions: string;
          addedAt: string;
          email: string;
          examStatus: string;
          name: string;
        };
        empty: string;
        filtersClear: string;
        filtersToggle: string;
        helpTooltip: string;
        noAvailableParticipants: string;
        noEligibleParticipants: string;
        removeTooltip: string;
        searchPlaceholder: string;
        title: string;
      };
      practicalAttempts: {
        abandonButton: string;
        abandonTooltip: string;
        attemptChip: string;
        attemptsUsed: string;
        completeButton: string;
        completeTooltip: string;
        detail: {
          answerKey: string;
          emptyAttempt: string;
          linkCopied: string;
          noAttachments: string;
          pdfPreviewError: string;
          pdfPreviewLoading: string;
          pdfPreviewPager: string;
          questions: string;
          reports: string;
          shareButton: string;
          shareError: string;
          title: string;
        };
        limitReached: string;
        maxAttempts: string;
        noParticipants: string;
        passed: string;
        startButton: string;
        startError: string;
        startSuccess: string;
        status: Record<PracticalExamAttemptStatusDto, string>;
        statusUpdateError: string;
        statusUpdateSuccess: string;
        title: string;
      };
      questionPools: {
        attachButton: string;
        browseTooltip: string;
        detachError: string;
        detachSuccess: string;
        detachTooltip: string;
        empty: string;
        poolCount: string;
        questionsCount: string;
        title: string;
        uploadButton: string;
        uploadToPoolTooltip: string;
      };
      questions: {
        addButton: string;
        cancelButton: string;
        columns: {
          actions: string;
          answerKey: string;
          question: string;
        };
        empty: string;
        fields: {
          answerKey: string;
          questionText: string;
        };
        generateSample: string;
        removeTooltip: string;
        saveButton: string;
        searchPlaceholder: string;
        title: string;
      };
      tabs: {
        attempts: string;
        config: string;
        examDays: string;
        examDaysLockedReason: string;
        participants: string;
        questions: string;
      };
      title: string;
    };
    examStageStatus: Record<ExamStageStatusDto, string>;
    filters: {
      allStatuses: string;
      searchButton: string;
      searchPlaceholder: string;
      status: string;
    };
    formDialog: {
      cancelButton: string;
      clearDeadline: string;
      createButton: string;
      createError: string;
      createSuccess: string;
      createTitle: string;
      deadlineHelp: string;
      deadlineLabel: string;
      deadlinePastConfirm: string;
      deadlinePastWarning: string;
      deadlineValidation: string;
      description: string;
      descriptionMaxLength: string;
      editTitle: string;
      nameLabel: string;
      nameMaxLength: string;
      nameRequired: string;
      saveButton: string;
      savingButton: string;
      status: string;
      updateError: string;
      updateSuccess: string;
    };
    itemRow: {
      createdAt: string;
      deleteDisabledTooltip: string;
      deleteTooltip: string;
      openTooltip: string;
    };
    loadError: string;
    loading: string;
    newButton: string;
    practicalExam: {
      attachDialog: {
        attachButton: string;
        attachError: string;
        attachingButton: string;
        attachSuccess: string;
        cancelButton: string;
        noPools: string;
        questionCount: string;
        searchButton: string;
        searchPlaceholder: string;
        title: string;
      };
      poolCard: {
        detachButton: string;
        questionsLabel: string;
        showQuestions: string;
        uploadToPoolButton: string;
      };
      questionsBrowser: {
        addAttachmentButton: string;
        answerKeyLabel: string;
        areaAll: string;
        attachmentDeleteError: string;
        attachmentDeleteSuccess: string;
        attachmentsLabel: string;
        deleteAttachment: string;
        downloadAttachment: string;
        globalPassLabel: string;
        globalPassTooltip: string;
        noAttachments: string;
        noQuestions: string;
        noReports: string;
        previewAttachment: string;
        previewCloseButton: string;
        questionsSection: string;
        reportChipLabel: string;
        reportsSection: string;
        searchPlaceholder: string;
        subquestionsLabel: string;
      };
      reportAttachmentDialog: {
        cancelButton: string;
        chooseFileButton: string;
        dragDropText: string;
        errorToast: string;
        fileLabel: string;
        fileRequired: string;
        fileTooLarge: string;
        hint: string;
        invalidFileType: string;
        successToast: string;
        title: string;
        uploadButton: string;
        uploadingButton: string;
      };
      richKeyEditor: {
        uploadError: string;
        uploading: string;
      };
      uploadPoolDialog: {
        appendTitle: string;
        cancelButton: string;
        chooseFileButton: string;
        dragDropText: string;
        errorToast: string;
        fileLabel: string;
        fileRequired: string;
        formatColumns: string;
        formatTitle: string;
        formatTypes: string;
        nameHelp: string;
        nameLabel: string;
        successToast: string;
        title: string;
        uploadButton: string;
        uploadingButton: string;
        validationErrorsTitle: string;
      };
      uploadToExistingPoolDialog: {
        cancelButton: string;
        chooseFileButton: string;
        dragDropText: string;
        errorToast: string;
        fileLabel: string;
        fileRequired: string;
        successToast: string;
        title: string;
        uploadButton: string;
        uploadingButton: string;
        validationErrorsTitle: string;
      };
    };
    questionPools: {
      filters: {
        allTypes: string;
        search: string;
        searchPlaceholder: string;
      };
      table: {
        actions: string;
        browseButton: string;
        createdAt: string;
        name: string;
        noData: string;
        questionCount: string;
        rowsPerPage: string;
        type: string;
        uploadButton: string;
      };
      title: string;
    };
    questionsBrowser: {
      explanationLabel: string;
      noResults: string;
      questionCount: string;
      rankLabel: string;
      searchPlaceholder: string;
      sectionPlaceholder: string;
      singleChoiceLabel: string;
      tabPool: string;
      tabStage: string;
      title: string;
      typeAll: string;
      typeRank: string;
      typeSingleChoice: string;
    };
    status: Record<CertificationStatusDto, string>;
    stepCard: {
      configured: string;
      instructionsTooltip: string;
      notConfigured: string;
      stepLabel: string;
    };
    stepLabels: {
      comingSoon: string;
      developmentCenter: string;
      devPlan: string;
      knowledgeTest: string;
      notConfigured: string;
      participants: string;
      practicalTest: string;
      selfAssessment: string;
    };
    summary: {
      active: string;
      completed: string;
      draft: string;
      total: string;
    };
    surveyStep: {
      activationDialog: {
        cancel: string;
        confirm: string;
        description: string;
        error: string;
        itemCertification: string;
        itemStage: string;
        success: string;
        title: string;
      };
      assignExisting: string;
      changeButton: string;
      changeSurveyTooltip: string;
      createNew: string;
      deadlineLabel: string;
      deadlinePastTooltip: string;
      detachButton: string;
      detachSurveyTooltip: string;
      noParticipants: string;
      noSurveyDescription: string;
      noSurveyTitle: string;
      participants: string;
      startDisabledTooltip: string;
      status: {
        ACTIVE: string;
        CANCELLED: string;
        COMPLETED: string;
        DRAFT: string;
      };
      statusAction: {
        cancel: string;
        complete: string;
        start: string;
      };
    };
    table: {
      actions: string;
      createdBy: string;
      deadline: string;
      name: string;
      noData: string;
      status: string;
      steps: string;
    };
    testStageConfig: {
      activateBlockedReason: string;
      bar: {
        passPrefix: string;
        questionsUnit: string;
        resultVisibilityWindow: string;
      };
      cancelButton: string;
      configureButton: string;
      editButton: string;
      fields: {
        allowBackNavigation: string;
        backNavEnabled: string;
        noLimit: string;
        numberOfQuestions: string;
        passingThreshold: string;
        resultVisibility: string;
        resultVisibilityWindowMinutes: string;
        resultVisibilityWindowMinutesHint: string;
        timeExtensionHint: string;
        timeExtensionMinutes: string;
        timeLimitMinutes: string;
      };
      label: string;
      notConfigured: string;
      pools: {
        attachButton: string;
        attachError: string;
        browseButton: string;
        detachBlockedByActiveTerm: string;
        detachButton: string;
        detachError: string;
        none: string;
        poolCount: string;
        poolQuestionCount: string;
        questionsLabel: string;
        title: string;
        uploadButton: string;
        uploadToPoolButton: string;
      };
      resultVisibilityOptions: {
        none: string;
        resultOnly: string;
        resultWithQuestions: string;
        resultWithScore: string;
      };
      saveButton: string;
      saveError: string;
      saveSuccess: string;
      sections: {
        available: string;
        exceedsAvailable: string;
        none: string;
        title: string;
        total: string;
        totalLabel: string;
      };
    };
    testStageDetail: {
      backButton: string;
      label: string;
      loading: string;
      notFound: string;
      notInitialized: string;
      subtitle: string;
      tabs: {
        config: string;
        configLockedReason: string;
        participants: string;
        participantsLockedReason: string;
        pools: string;
        terms: string;
        termsLockedReason: string;
      };
      title: string;
    };
    title: string;
    uploadPoolDialog: {
      appendTitle: string;
      cancelButton: string;
      chooseFileButton: string;
      dragDropText: string;
      errorToast: string;
      fileLabel: string;
      fileRequired: string;
      nameHelp: string;
      nameLabel: string;
      successToast: string;
      title: string;
      uploadButton: string;
      uploadingButton: string;
      validationErrorsTitle: string;
    };
    uploadToExistingPoolDialog: {
      cancelButton: string;
      chooseFileButton: string;
      dragDropText: string;
      errorToast: string;
      fileLabel: string;
      fileRequired: string;
      successToast: string;
      title: string;
      uploadButton: string;
      uploadingButton: string;
      validationErrorsTitle: string;
    };
  };
  changeHistory: {
    filters: {
      action: string;
      actions: {
        activate: string;
        assign: string;
        create: string;
        deactivate: string;
        delete: string;
        toggleOverride: string;
        unassign: string;
        update: string;
      };
      all: string;
      changedAfter: string;
      changedBefore: string;
      changedByUserEmail: string;
      changeType: string;
      changeTypes: {
        permissionEdit: string;
        roleEdit: string;
        rolePermissionAssignment: string;
        userPermissionChange: string;
        userRoleChange: string;
      };
      clearFilters: string;
      targetUserEmail: string;
    };
    table: {
      actions: {
        ACTIVATE: string;
        ASSIGN: string;
        CREATE: string;
        DEACTIVATE: string;
        DELETE: string;
        TOGGLE_OVERRIDE: string;
        UNASSIGN: string;
        UPDATE: string;
      };
      changeTypes: {
        PERMISSION_EDIT: string;
        ROLE_EDIT: string;
        ROLE_PERMISSION_ASSIGNMENT: string;
        USER_PERMISSION_CHANGE: string;
        USER_ROLE_CHANGE: string;
      };
      error: string;
      fieldName: string;
      headers: {
        action: string;
        changedAt: string;
        changedBy: string;
        changeType: string;
        description: string;
        id: string;
        permission: string;
        role: string;
        targetUser: string;
      };
      loading: string;
      newValue: string;
      noData: string;
      oldValue: string;
      rowsPerPage: string;
    };
  };
  confirmPermissionAction: {
    actions: {
      activatePermission: { description: string; title: string; warning: string };
      addIndividualPermission: { description: string; title: string; warning: string };
      addRoleToUser: { description: string; title: string; warning: string };
      assignPermissionToRole: { description: string; title: string; warning: string };
      deactivatePermission: { description: string; title: string; warning: string };
      deactivateRolePermission: { description: string; title: string; warning: string };
      removeIndividualPermission: { description: string; title: string; warning: string };
      removePermissionFromRole: { description: string; title: string; warning: string };
      removeRoleFromUser: { description: string; title: string; warning: string };
      toggleRole: { description: string; title: string; warning: string };
    };
    cancel: string;
    confirm: string;
  };
  dictionaries: {
    editDialog: {
      active: string;
      cancel: string;
      englishName: string;
      polishName: string;
      save: string;
      saving: string;
      title: string;
    };
    filters: {
      active: string;
      allStatuses: string;
      allTypes: string;
      inactive: string;
      name: string;
      searchByName: string;
      status: string;
      type: string;
    };
    table: {
      actions: string;
      code: string;
      edit: string;
      englishName: string;
      noData: string;
      noFilters: string;
      polishName: string;
      rowsPerPage: string;
      status: {
        false: string;
        true: string;
      };
      statusHeader: string;
      type: string;
    };
    title: string;
  };
  employeesList: {
    buttons: {
      export: string;
    };
    content: {
      table: {
        active: string;
        email: string;
        externalEmployeeId: string;
        firstName: string;
        inactive: string;
        lastName: string;
        openProfile: string;
        openProfileUnavailable: string;
      };
    };
    dialog: {
      activateInfo: string;
      cancel: string;
      confirm: string;
      deactivateInfo: string;
      message: string;
      title: string;
    };
    form: {
      externalEmployeeId: string;
      firstName: string;
      lastName: string;
    };
  };
  groups: {
    certification: string;
    content: string;
    management: string;
    tools: string;
  };
  impersonation: {
    blockedDisabled: string;
    blockedNoRole: string;
    blockedPrivileged: string;
    noEmployeeRecordChip: string;
    noRoleChip: string;
    privilegedChip: string;
  };
  legalDocuments: {
    currentBadge: string;
    delete: string;
    deleteDialog: {
      cancel: string;
      confirm: string;
      message: string;
      title: string;
    };
    dropzoneHintPrefix: string;
    dropzoneLabel: string;
    dropzoneMaxSize: string;
    empty: string;
    info: string;
    preview: string;
    setCurrent: string;
    versionLabel: string;
    versionsTitle: string;
  };
  news: {
    actions: {
      archive: string;
      backToDraft: string;
      cancel: string;
      delete: string;
      edit: string;
      error: string;
      preview: string;
      publish: string;
    };
    categories: Record<NewsCategoryDto, string>;
    confirmations: {
      archive: { confirm: string; message: string; title: string };
      delete: { confirm: string; message: string; title: string };
      draft: { confirm: string; message: string; title: string };
      publish: { confirm: string; message: string; title: string };
    };
    editor: {
      cancel: string;
      categoryLabel: string;
      categoryRequired: string;
      changeImage: string;
      chooseImage: string;
      contentHelp: string;
      contentLabel: string;
      createError: string;
      createTitle: string;
      editTitle: string;
      imageClear: string;
      imageDropActive: string;
      imageDropReplace: string;
      imageDropSubtitle: string;
      imageDropTitle: string;
      imageHelp: string;
      imageLabel: string;
      imageSelected: string;
      imageSizeError: string;
      imageTypeError: string;
      loading: string;
      publishNow: string;
      save: string;
      saveChanges: string;
      saveDraft: string;
      saving: string;
      subtitle: string;
      titleLabel: string;
      titleMaxLength: string;
      titlePlaceholder: string;
      titleRequired: string;
      toolbar: {
        bold: string;
        image: string;
        italic: string;
        link: string;
        linkDialog: { apply: string; cancel: string; title: string };
        orderedList: string;
        underline: string;
        unorderedList: string;
        video: string;
      };
      untitledDraft: string;
      updateError: string;
      videoError: string;
      videoProcessing: string;
      videoProcessingFailed: string;
      videoTypeError: string;
    };
    empty: {
      title: string;
    };
    filters: {
      allCategories: string;
      allStatuses: string;
      category: string;
      searchPlaceholder: string;
      status: string;
    };
    newButton: string;
    preview: {
      close: string;
      emptyContent: string;
      subtitle: string;
      title: string;
      videoError: string;
    };
    statuses: Record<NewsStatusDto, string>;
    subtitle: string;
    table: {
      actions: string;
      category: string;
      createdAt: string;
      error: string;
      loading: string;
      noData: string;
      noImage: string;
      publishedAt: string;
      rowsPerPage: string;
      status: string;
      title: string;
      updatedAt: string;
    };
    title: string;
  };
  noPermissions: string;
  permissionDetails: {
    active: string;
    category: string;
    code: string;
    description: string;
    inactive: string;
    name: string;
    noDescription: string;
    status: string;
    title: string;
  };
  permissionsEmployees: {
    backToList: string;
    columns: {
      department: string;
      email: string;
      employee: string;
      sap: string;
      status: string;
    };
    description: string;
    detail: {
      activate: string;
      allWithCount: string;
      assignedPermissions: string;
      assignedRoles: string;
      availablePermissions: string;
      availableRoles: string;
      categoryNone: string;
      categoryUncategorized: string;
      deactivate: string;
      fromRole: string;
      hrbpTitle: string;
      individualPermissions: string;
      noAssignedPermissions: string;
      noAssignedRoles: string;
      noAvailablePermissions: string;
      noAvailableRoles: string;
      noPermissionsMatch: string;
      noResults: string;
      noRolePermissions: string;
      permissionCount: string;
      permissionsTitle: string;
      roleDisableSuffix: string;
      roleEnableSuffix: string;
      rolePermissions: string;
      rolesTitle: string;
      searchByNameOrCode: string;
      statusActive: string;
      statusDisabled: string;
      systemBadge: string;
      systemRolesInfoBody: string;
      systemRolesInfoTitle: string;
      toast: {
        bulkPartial: string;
        cannotRemoveSystemRole: string;
        individualsAdded: string;
        individualsAddError: string;
        individualsRemoved: string;
        individualsRemoveError: string;
        noRolesSelected: string;
        permissionActivated: string;
        permissionActivatedForRoles: string;
        permissionDeactivated: string;
        permissionDeactivatedForRoles: string;
        permissionUpdateError: string;
        roleAdded: string;
        roleAddError: string;
        roleDisabled: string;
        roleEnabled: string;
        roleNotFoundForPermission: string;
        rolePermissionUpdateError: string;
        roleRemoved: string;
        roleRemoveError: string;
        roleUpdateError: string;
      };
    };
    emptyResultsDescription: string;
    emptyResultsTitle: string;
    loading: string;
    onlyModified: string;
    rowsPerPage: string;
    searchPlaceholder: string;
    startDescription: string;
    startTitle: string;
    statusModified: string;
    title: string;
  };
  permissionsTable: {
    active: string;
    allCategories: string;
    columnActions: string;
    columnCategory: string;
    columnCode: string;
    columnDescription: string;
    columnName: string;
    columnStatus: string;
    count: string;
    deleteCentralInfo: string;
    editCentralInfo: string;
    emptyDescription: string;
    emptyFilteredDescription: string;
    emptyFilteredTitle: string;
    emptyTitle: string;
    inactive: string;
    loading: string;
    searchPlaceholder: string;
    toggleError: string;
    toggleSuccess: string;
  };
  professionalActivityDefinitions: {
    documents: {
      aiContext: string;
      aiContextTooltip: string;
      deleteDialog: {
        cancel: string;
        confirm: string;
        message: string;
        title: string;
      };
      dropzoneHintPrefix: string;
      dropzoneLabel: string;
      dropzoneMaxSize: string;
      embeddingStatus: {
        available: string;
        failed: string;
        noContent: string;
        notEmbedded: string;
        processing: string;
      };
      empty: string;
      loading: string;
      reembed: string;
      title: string;
    };
    editDialog: {
      cancel: string;
      description: string;
      developmentProgram: string;
      editYear: string;
      name: string;
      save: string;
      saving: string;
      status: string;
      statusValues: {
        COMPLETED: string;
        IN_PROGRESS: string;
        PLANNED: string;
      };
      title: string;
    };
    searchPlaceholder: string;
    table: {
      description: string;
      developmentProgram: string;
      editYear: string;
      name: string;
      noData: string;
      rowsPerPage: string;
      status: string;
      statusValues: {
        COMPLETED: string;
        IN_PROGRESS: string;
        PLANNED: string;
      };
      updatedAt: string;
    };
    title: string;
  };
  ragDocuments: {
    form: {
      fields: {
        categories: {
          label: string;
          placeholder: string;
        };
        description: {
          label: string;
        };
        file: {
          accepted: string;
          dropzoneLabel: string;
          remove: string;
        };
        tags: {
          label: string;
          placeholder: string;
        };
        title: {
          label: string;
        };
      };
      status: {
        awaitingValidationResolution: string;
        close: string;
        error: string;
        finished: string;
        inProgress: string;
        notStarted: string;
        processing: string;
        readingDocument: string;
        validationFailed: string;
      };
      submitButton: string;
      submitButtonLoading: string;
      title: string;
      toasts: {
        initError: string;
        sseError: string;
        uploadError: string;
        uploadSuccess: string;
      };
    };
  };
  roleAssignments: {
    allWithCount: string;
    assignAriaLabel: string;
    assignedTitle: string;
    assignError: string;
    assignSuccess: string;
    availableTitle: string;
    categoryWithCount: string;
    confirmDetails: string;
    count: string;
    emptyAssigned: string;
    emptyAvailable: string;
    emptyFiltered: string;
    noRoles: string;
    removeAriaLabel: string;
    removeError: string;
    removeSuccess: string;
    rolePlaceholder: string;
    rolesTitle: string;
    searchPlaceholder: string;
    selectAll: string;
    selectedCount: string;
  };
  roleForm: {
    cancel: string;
    colorHint: string;
    colorLabel: string;
    createTitle: string;
    descriptionLabel: string;
    editTitle: string;
    nameLabel: string;
    save: string;
  };
  roles: {
    badgePermissions: string;
    badgePermissionsSystem: string;
    count: string;
    emptyDescription: string;
    emptySearchDescription: string;
    emptySearchTitle: string;
    emptyTitle: string;
    loading: string;
    searchPlaceholder: string;
    updateError: string;
    updateSuccess: string;
  };
  sections: {
    accounts: {
      description: string;
    };
    data: {
      historyDescription: string;
      historyTitle: string;
      uploadDescription: string;
      uploadTitle: string;
    };
    developmentCycles: {
      applyToAllChip: string;
      campaignStatus: Record<DevelopmentCycleCampaignStatusDto, string>;
      campaignType: {
        CERTIFICATION: string;
        DEFAULT: string;
        MDR: string;
      };
      cancelCampaign: {
        cancel: string;
        confirm: string;
        description: string;
        notice: string;
        title: string;
      };
      delete: {
        cancel: string;
        confirm: string;
        description: string;
        title: string;
      };
      description: string;
      fields: {
        certification: string;
        certificationFallback: string;
        covered: string;
        coveredAll: string;
        coveredEmpty: string;
        developmentDirection: string;
        name: string;
        noName: string;
        tasksStartDate: string;
        window: string;
      };
      filters: {
        anyStatus: string;
        anyType: string;
        searchPlaceholder: string;
        statusLabel: string;
        typeLabel: string;
      };
      form: {
        applyToAll: string;
        applyToAllHint: string;
        applyToAllNotice: string;
        campaignType: string;
        campaignTypeHint: {
          CERTIFICATION: string;
          DEFAULT: string;
          MDR: string;
        };
        campaignTypeOption: {
          CERTIFICATION: string;
          DEFAULT: string;
          MDR: string;
        };
        cancel: string;
        certification: string;
        certificationEmpty: string;
        certificationHint: string;
        certificationPlaceholder: string;
        createTitle: string;
        cycleValidFrom: string;
        cycleValidTo: string;
        developmentDirection: string;
        developmentDirectionHint: string;
        developmentDirectionPlaceholder: string;
        editTitle: string;
        errors: {
          conflict: string;
          developmentDirection: string;
          generic: string;
          tasksStartDate: string;
          window: string;
        };
        name: string;
        namePlaceholder: string;
        sapCheck: {
          accepted: string;
          button: string;
          checking: string;
          copied: string;
          copyFailed: string;
          copyRejected: string;
          error: string;
          reason: {
            ALREADY_IN_OTHER_CAMPAIGN: string;
            NOT_IN_MDR_PROCESS: string;
            UNKNOWN_SAP: string;
          };
          rejectedRow: string;
          rejectedTitle: string;
        };
        sapImport: {
          clearConfirmAction: string;
          clearConfirmBody: string;
          clearConfirmTitle: string;
          clearList: string;
          dropzoneBottom: string;
          dropzoneTop: string;
          errorTooMany: string;
          errorUnreadable: string;
          fileHint: string;
          modeAppend: string;
          modeBody: string;
          modeCancel: string;
          modeReplace: string;
          modeTitle: string;
          rejectedRow: string;
          rejectedTitle: string;
          showAll: string;
          showLess: string;
          summaryDuplicates: string;
          summarySuccess: string;
        };
        save: string;
        status: string;
        statusHint: Record<DevelopmentCycleCampaignStatusDto, string>;
        statusOption: Record<DevelopmentCycleCampaignStatusDto, string>;
        targetSaps: string;
        targetSapsAdd: string;
        targetSapsEmpty: string;
        targetSapsHint: string;
        targetSapsPlaceholder: string;
        tasksStartDate: string;
      };
      impact: {
        activation: string;
        activeEdit: string;
        cancel: string;
        confirm: string;
        finish: string;
        title: string;
        withdrawal: string;
      };
      members: {
        back: string;
        detail: {
          back: string;
          cycleCampaign: string;
          cycleDirection: string;
          cycleState: string;
          cycleWindow: string;
          noAccount: string;
          noPlans: string;
          noPlansTitle: string;
          noTaskReason: string;
          noTasks: string;
          noTasksTitle: string;
          p1: string;
          pageDescription: string;
          pageTitle: string;
          plansTitle: string;
          taskDeadline: string;
          taskDescription: string;
          taskStatus: string;
          tasksTitle: string;
          taskTarget: string;
          taskTrigger: string;
          thisCampaign: string;
        };
        emptyDescription: string;
        emptyTitle: string;
        error: string;
        errorTitle: string;
        filters: {
          anyPlanStatus: string;
          planStatusLabel: string;
          searchPlaceholder: string;
          withoutAccount: string;
          withoutTask: string;
        };
        no: string;
        pageDescription: string;
        pageTitle: string;
        planStatus: {
          ARCHIVED: string;
          CANCELLED: string;
          COMPLETED: string;
          DRAFT: string;
          NONE: string;
          READY_FOR_REALIZATION: string;
          SUPERVISOR_APPROVED: string;
          SUPERVISOR_REJECTED: string;
        };
        reason: {
          BEFORE_TASKS_START: string;
          CAMPAIGN_NOT_IN_PROGRESS: string;
          CATCH_ALL: string;
          NO_USER_ACCOUNT: string;
          PENDING_SCAN: string;
          PLAN_EXISTS: string;
        };
        source: {
          APPLY_TO_ALL: string;
          TARGETED: string;
        };
        summary: {
          covered: string;
          withOpenTask: string;
          withPlan: string;
          withUserAccount: string;
        };
        table: {
          account: string;
          name: string;
          p1: string;
          plan: string;
          source: string;
          task: string;
        };
        taskType: {
          PLAN_INITIATION: string;
          PLAN_REQUIRED: string;
        };
        yes: string;
      };
      noCampaignInProgress: string;
      sweep: {
        button: string;
        description: string;
        result: string;
        testBadge: string;
        title: string;
      };
      table: {
        actions: string;
        campaignType: string;
        cancelAction: string;
        covered: string;
        coveredAll: string;
        coveredEmpty: string;
        createButton: string;
        deleteAction: string;
        downloadPlansAction: string;
        downloadPlansColumn: string;
        editAction: string;
        empty: string;
        emptyFiltered: string;
        emptyFilteredTitle: string;
        emptyTitle: string;
        finishAction: string;
        members: string;
        membersAction: string;
        name: string;
        startAction: string;
        status: string;
        tasksStartDate: string;
        title: string;
        window: string;
      };
    };
    employees: {
      description: string;
    };
    legalDocuments: {
      description: string;
    };
    permissions: {
      description: string;
    };
  };
  sidebar: {
    backToStart: string;
    collapseAriaLabelCollapsed: string;
    collapseAriaLabelExpanded: string;
    subtitle: string;
  };
  structureBrowser: {
    axis: {
      hrbp: string;
      label: string;
      supervisor: string;
    };
    backToList: string;
    columns: {
      department: string;
      name: string;
      peopleCount: string;
      position: string;
      roles: string;
      sapNumber: string;
    };
    description: {
      accounts: string;
      scopeHrbp: string;
      scopeSupervisor: string;
    };
    empty: {
      noPeople: string;
      noSupervisors: string;
    };
    team: {
      title: string;
      total: string;
    };
    title: string;
  };
  successionPermissions: {
    comingSoon: string;
    description: string;
    errors: {
      loadingData: string;
      loadingUnits: string;
    };
    loading: {
      data: string;
      units: string;
    };
    messages: {
      hrbpHqInfo: string;
      noDataForSelectedUnits: string;
      saving: string;
      selectUnits: string;
    };
    table: {
      headers: {
        employeeCount: string;
        unitPosition: string;
      };
    };
    unitSelection: {
      allButton: string;
      clearAllButton: string;
      label: string;
      moreChipLabel: string;
      placeholder: string;
      remainingUnitsTooltip: string;
    };
  };
  surveyDetail: {
    backButton: string;
    backToCertification: string;
    backToSurveys: string;
    createdAt: string;
    createdBy: string;
    deadline: string;
    editButton: string;
    label: string;
    overview: {
      areas: string;
      categories: string;
      categoryLink: string;
      closedQuestions: string;
      negative: string;
      noCategoriesFound: string;
      openQuestions: string;
      positive: string;
      procedureDescription: string;
      procedureName: string;
      questions: string;
      scale: string;
      searchCategories: string;
      selectCategoryPrompt: string;
      threshold: string;
      total: string;
    };
    participants: {
      actions: string;
      answers: {
        allAreas: string;
        allCategories: string;
        answer: string;
        answerDuration: string;
        areaFilter: string;
        categoryFilter: string;
        error: string;
        loading: string;
        noData: string;
        questionNumber: string;
        report: {
          downloadButton: string;
          downloading: string;
          error: string;
          reportType: {
            EMPLOYEE_SURVEY_ANSWERS: string;
          };
          subtitle: string;
          title: string;
        };
        rowsPerPage: string;
        searchPlaceholder: string;
        summary: {
          allCategoriesMet: string;
          categoriesCount: string;
          competencyWorkRequired: string;
          goToResources: string;
          greatJob: string;
          howToImprove: string;
          loading: string;
          procedureDescription: string;
          procedureName: string;
          questionNumber: string;
          supportMaterials: string;
          viewAnswers: string;
        };
        tabAnswers: string;
        tabReport: string;
        tabSummary: string;
        title: string;
        totalAnswers: string;
      };
      assignedAt: string;
      completedAt: string;
      dates: string;
      details: string;
      email: string;
      hasSurveyAssigned: string;
      name: string;
      notificationSent: string;
      position: string;
      search: string;
      startedAt: string;
      status: Record<SurveyAssignmentStatusDto, string> & { all: string; null: string };
      statusLabel: string;
      table: {
        actions: string;
        error: string;
        loading: string;
        noData: string;
        rowsPerPage: string;
      };
      viewAnswers: string;
    };
    questions: {
      all: string;
      area: string;
      assignedTo: string;
      category: string;
      categoryDetails: string;
      categoryLink: string;
      employee: string;
      filters: string;
      group: string;
      position: string;
      procedureDescription: string;
      procedureName: string;
      total: string;
      type_CLOSED: string;
      type_OPEN: string;
    };
    reports: {
      download: string;
      downloading: string;
      error: string;
      reportType: {
        EMPLOYEE_SURVEY_ANSWERS: string;
      };
      subtitle: string;
    };
    status: string;
    statusAction: {
      cancel: string;
      complete: string;
      start: string;
    };
    statusUpdateError: string;
    statusUpdateSuccess: string;
    tabs: {
      overview: string;
      participants: string;
      questions: string;
      reports: string;
    };
  };
  surveys: {
    addButton: string;
    dialog: {
      cancel: string;
      deadline: string;
      deadlineHelp: string;
      dragDropText: string;
      file: string;
      fileHelp: string;
      name: string;
      save: string;
      saving: string;
      title: string;
      uploadSuccess: string;
    };
    editDialog: {
      cancel: string;
      deadline: string;
      deadlineHelp: string;
      deadlineMustBeFuture: string;
      name: string;
      nameMaxLength: string;
      nameRequired: string;
      save: string;
      saving: string;
      status: string;
      statusLocked: string;
      title: string;
      updateError: string;
      updateSuccess: string;
    };
    filters: {
      search: string;
    };
    status: {
      ACTIVE: string;
      CANCELLED: string;
      COMPLETED: string;
      DRAFT: string;
    };
    statusUpdateError: string;
    statusUpdateSuccess: string;
    table: {
      actions: string;
      author: string;
      createdAt: string;
      deadline: string;
      details: string;
      edit: string;
      error: string;
      loading: string;
      name: string;
      noData: string;
      participants: string;
      report: string;
      rowsPerPage: string;
      status: string;
    };
    title: string;
  };
  tabs: {
    accountsManagement: string;
    certificationSubTabs: {
      certification: string;
      questionPools: string;
      surveys: string;
    };
    changeHistory: string;
    dataManagement: string;
    dataManagementUpload: string;
    developmentCycles: string;
    devPlanTester: string;
    dictionaries: string;
    employeesManagement: string;
    impersonation: string;
    legalDocuments: string;
    news: string;
    permissions: string;
    permissionSubTabs: {
      assignments: string;
      employees: string;
      hrbpPermissions: string;
      permissions: string;
      roles: string;
    };
    professionalActivityDefinitions: string;
    ragDocuments: string;
    structureBrowser: string;
    successionPermissions: string;
    surveys: string;
    taskCreator: string;
  };
  taskCreator: {
    creating: string;
    deadline: string;
    description: string;
    error: string;
    resourceType: Record<ResourceTypeDto, string>;
    sourceResourceType: string;
    sourceResourceValue: string;
    submit: string;
    subtitle: string;
    targetResourceType: string;
    targetResourceValue: string;
    title: string;
  };
  title: string;
};

type StageInstructionBody = {
  adminSteps: string;
  employeeView: string;
  purpose: string;
  rules: string;
  transition: string;
};

export const adminPanelTranslation: AdminPanelTranslation = {
  certifications: {
    adminInstructions: {
      closeButton: 'Close',
      drawerTitle: 'Admin Instructions',
      sectionTitles: {
        adminSteps: 'What the admin does',
        employeeView: 'What the employee sees and when',
        purpose: 'Stage purpose',
        rules: 'Rules',
        transition: 'Moving to the next stage',
      },
      stages: {
        developmentCenter: {
          adminSteps:
            '1. Start the Development Center stage — it has no name of its own, a certification either runs a DC or not.\n\n2. Set the expected score on the file scale — without it a participant score has no reference point.\n\n3. Set the date from which participants can see their reports.\n\n4. Upload the session results spreadsheet. If someone in the sheet took part in neither the knowledge test nor the practical exam, you get a remark — the import still goes through if you decide to continue.\n\n5. Upload the ZIP archive with participant PDF reports.',
          employeeView:
            'The participant sees the Development Center tile in their certification path.\n\nThey can download their PDF report only from the configured date and only if a report was uploaded for them.\n\nIf the certification does not include a Development Center, the participant only sees a note about it.',
          purpose:
            'Development Center is a managerial competency assessment run by assessors outside the application. The results and the individual report are loaded into the system and feed both the certification path and the employee development plan.',
          rules:
            'The stage is optional — a certification may not include it.\n\nResults belong to a specific certification: the same employee can have DC results in several certifications.\n\nThe stage is completed once the participant has a current session result.\n\nUploading the spreadsheet again for the same certification creates a new version of the results.',
          transition:
            'Development Center results are used when building the development plan — the final stage of the certification.',
        },
        exam: {
          adminSteps:
            '1. Initialize the stage — give it a name and create the practical exam record.\n\n2. Configure the exam — add questions/tasks, set the pass threshold and duration.\n\n3. Create exam days — schedule dates and time slots in which individual exams take place.\n\n4. Assign participants to exam days and specific slots. Only assigned participants can take the exam.\n\n5. During the exam, the examiner evaluates the task performance directly in the system.\n\n6. Change the stage status (Draft → Active → Completed) using the action button in the top-right corner of the stage card.',
          employeeView:
            'The employee sees the practical exam stage only when the stage status is "Active" and they are assigned to an exam day.\n\nIn the employee panel, the exam term is visible (date, time, location) along with the assigned examiner.\n\nAfter the exam, the employee sees their result and status (passed / failed) once the examiner completes the evaluation.',
          purpose:
            "The practical exam verifies the employee's skills in real professional tasks. It's the final step confirming actual competence — the theory from the knowledge test must translate into practice.",
          rules:
            'The practical exam is conducted by a designated examiner who evaluates task performance.\n\nThe participant must be assigned to a specific exam day in order to take it.\n\nThe exam result (pass/fail) is determined by the examiner and is not automatically calculated.\n\nThe stage can have status: Not initialized, Not started, In progress, Completed.',
          transition:
            'Successful completion of the practical exam is a condition for obtaining the certification. Once the stage is completed, the system records the employee as certified.\n\nThe next step (when available) is the Development Plan, generated based on gaps identified in the previous stages.',
        },
        plan: {
          adminSteps:
            'The Development Plan feature is under construction. Once available, the admin will be able to:\n\n1. Generate a development plan based on gaps identified in self-assessment, knowledge test and practical exam.\n\n2. Assign concrete development actions to the employee (trainings, tasks, mentoring).\n\n3. Monitor progress and close individual activities.',
          employeeView:
            'Once the feature is released, the employee will see their individual development plan with a list of recommended actions, deadlines and completion status for each task.',
          purpose:
            'The Development Plan is the post-exam stage — based on it, the employee receives individual guidance for further competence development. This stage closes the certification process and initiates employee growth in the areas where gaps were detected.',
          rules:
            "The Development Plan stage is currently unavailable (feature in progress).\n\nOnce released, the plan will be generated based on results from earlier stages and the employee's history.",
          transition:
            'The Development Plan is the last step of the certification process. Upon its completion, the entire employee certification process is closed.',
        },
        survey: {
          adminSteps:
            '1. Assign a survey to the certification — you can pick an existing one or create a new one in the "Assign survey" dialog.\n\n2. Set a completion deadline (optional) — employees will see the deadline in their panel.\n\n3. Track progress in the Participants section — you see who has completed the survey and who hasn\'t.\n\n4. If needed, detach the survey ("Detach" button) — note: existing answers are then lost.',
          employeeView:
            'The employee sees the survey in their panel the moment they are assigned as a certification participant and a self-assessment survey is attached to the certification.\n\nThey fill it in before starting the knowledge test — answers are saved and used to identify competence gaps.\n\nIf a deadline is set, the employee sees it along with reminder notifications.',
          purpose:
            'Self-assessment is the first step of the certification process. It lets the employee assess their own competence level before formal verification. This establishes a baseline and identifies areas needing development.',
          rules:
            "Self-assessment is a survey completed by the employee — it's not scored by the admin.\n\nOnly one survey can be attached to a given certification at a time.\n\nDetaching the survey removes its link to the certification, but employee answers are preserved in the system.",
          transition:
            'Self-assessment does not block progression to the next stage — completing it is recommended but not a hard prerequisite for launching the knowledge test.\n\nNext step: Knowledge Test (stage 2).',
        },
        test: {
          adminSteps:
            '1. Initialize the stage — create the knowledge test stage record (give it a name, e.g. "Knowledge Test Q2 2026").\n\n2. Configure the test: attach question pools, set number of questions, pass threshold (e.g. 70%) and duration.\n\n3. Create test terms ("New term") — each term is a specific session date and time. End time is computed automatically from the configured duration.\n\n4. Assign participants to the stage (by employee, SAP or position code), then to specific terms.\n\n5. Activate the stage (Draft → Active) — only then do employees see the test in their panel. Activation requires at least one term.\n\n6. If needed, extend the time of an individual term ("Extend time" button) for participants with additional needs.',
          employeeView:
            'The employee sees the test in their panel when:\n- the stage has status "Active",\n- the employee is assigned to the stage and to a specific term,\n- the term\'s start time has arrived.\n\nBefore the term starts, the employee only sees information about the scheduled session (name, date, time).\n\nOnce started, they can take the test — they have a set time to answer. After finishing, they see their result (pass/fail) and score, if configuration allows.',
          purpose:
            'The Knowledge Test is a formal verification of theoretical understanding of the certification topic. The employee answers randomly drawn questions from attached pools and must reach the set threshold to move on to the practical exam.',
          rules:
            'The test is available only within a scheduled term (time window).\n\nQuestions are drawn randomly from attached pools according to the configured count.\n\nPassing requires reaching a percentage threshold (configurable at the stage level).\n\nTerm status: New → In progress → Completed. Terms can be cancelled before they start.\n\nStage status: Draft (configuring), Active (available to employees), Completed (finished), Cancelled.',
          transition:
            'Passing the Knowledge Test is a condition for taking the Practical Exam (stage 3). Employees with a "Failed" result are not automatically moved forward — the admin decides whether they retake a future term.',
        },
      },
      stepPrefix: 'Step',
    },
    assignSurveyDialog: {
      assignError: 'Failed to assign survey',
      assignExistingTab: 'Assign existing',
      assignSuccess: 'Survey assigned successfully',
      chooseFileButton: 'Choose file',
      clearDeadline: 'Clear deadline',
      closeButton: 'Close',
      createAssignButton: 'Create & Assign',
      createError:
        'The survey could not be created. Check the file, for example whether any question numbers repeat, and try again.',
      createNewTab: 'Create new',
      creatingButton: 'Creating...',
      currentlyAssigned: 'Currently assigned:',
      deadlineHelp: 'Optional deadline for participants',
      deadlineLabel: 'Deadline',
      deadlinePastWarning: 'Deadline is in the past',
      deadlineValidation: 'Deadline must be today or in the future',
      detachButton: 'Detach',
      detachError: 'Failed to detach survey',
      detachSuccess: 'Survey detached successfully',
      dragDropText: 'Drag & drop or click to select .xlsx file',
      fileLabel: 'File (XLSX) *',
      fileRequired: 'File is required',
      nameMaxLength: 'Name can be at most 50 characters',
      nameRequired: 'Name is required',
      noSurveysFound: 'No assignable surveys found (only DRAFT status surveys can be assigned)',
      orSelectDifferent: 'or select a different survey',
      searchButton: 'Search',
      searchPlaceholder: 'Search surveys by name...',
      surveyNameLabel: 'Survey name *',
      title: 'Step 1: Self-Assessment Survey',
      validationErrorsTitle: 'Validation errors',
      validationErrorsToast: 'Validation errors found. Check details below.',
    },
    deleteDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Delete',
      deleteError: 'Failed to delete certification',
      deleteSuccess: 'Certification deleted successfully',
      deletingButton: 'Deleting...',
      messageEnd: '? This action cannot be undone. The linked survey will not be deleted.',
      messageStart: 'Are you sure you want to delete',
      title: 'Delete Certification',
    },
    detail: {
      backButton: 'Certifications',
      detachError: 'Failed to detach survey',
      detachSuccess: 'Survey detached',
      editButton: 'Edit',
      flowTitle: 'Certification Flow — 4 Steps',
      label: 'Certification',
      loading: 'Loading certification...',
      metaCreated: 'Created',
      metaDeadline: 'Deadline',
      metaUpdated: 'Updated',
      notFound: 'Certification not found',
      participants: {
        addedAt: 'Added',
        attempts_few: '{{count}} attempts',
        attempts_many: '{{count}} attempts',
        attempts_one: '{{count}} attempt',
        attempts_other: '{{count}} attempts',
        bestScore: 'Score {{score}}%',
        commonFilters: {
          clearAll: 'Clear all',
          position: 'Position',
          positionPlaceholder: 'Select positions...',
          search: 'Search',
          searchPlaceholder: 'First name, last name, email, SAP ID...',
          sort: 'Sort',
          sortOptions: {
            bestTestScoreDesc: 'Best test score ↓',
            examAttemptsDesc: 'Exam attempts ↓',
            lastNameAsc: 'Last name ↑',
            testAttemptsDesc: 'Test attempts ↓',
          },
          stageFiltersButton: 'Stage filters',
          title: 'Employee — shared filters',
        },
        drill: {
          actions: 'Actions',
          assigned: 'Assigned',
          assignedMetaNo: 'assigned: no',
          assignedMetaYes: 'assigned: yes',
          attempts: 'Attempts',
          attemptsMeta_few: '{{count}} attempts',
          attemptsMeta_many: '{{count}} attempts',
          attemptsMeta_one: '{{count}} attempt',
          attemptsMeta_other: '{{count}} attempts',
          bestScore: 'Best score',
          collapse: 'Collapse',
          comment: 'Comment',
          comments: 'Commission comments',
          commission: 'Commission',
          commissionRole: {
            CHAIRMAN: 'Chairman',
            HRBP: 'HRBP',
          },
          completedAt: 'Completed',
          correctOfTotal: 'Correct/Total',
          date: 'Date',
          daysTitle: 'Exam days',
          examTitle: 'Practical exam (stage 3)',
          expand: 'Expand',
          location: 'Location',
          no: 'No',
          noDays: 'No exam days.',
          noExam: 'No exam data.',
          noSurvey: 'No survey data.',
          noTerms: 'No test terms.',
          noTest: 'No test data.',
          notPassed: 'Failed',
          overall: 'Overall status',
          passed: 'Passed',
          questions: 'q.',
          score: 'Score',
          scoreMeta: 'score {{score}}%',
          startedAt: 'Started',
          status: 'Status',
          surveyTitle: 'Survey (stage 1)',
          term: 'Term',
          termsTitle: 'Test terms',
          testTitle: 'Knowledge test (stage 2)',
          time: 'Time',
          viewAnswers: 'View answers',
          viewExam: 'View exam',
          yes: 'Yes',
        },
        email: 'Email',
        error: 'Failed to load participants',
        filters: {
          clear: 'Clear',
          csvHint: 'Separate values with comma or space.',
          employeeSection: 'Employee',
          passed: 'Passed',
          positionCodes: 'Position codes (SAP)',
          regionCodes: 'Region codes',
          scoreMax: 'Max score %',
          scoreMin: 'Min score %',
          status: 'Status',
          surveyAssigned: 'Survey assigned',
          title: 'Filters',
          tri: {
            any: 'Any',
            no: 'No',
            yes: 'Yes',
          },
        },
        filterStagesPlaceholder: 'Filter by stage',
        flashcardDownload: {
          cancel: 'Cancel',
          confirm: 'Download',
          description:
            'The flashcard holds all of the participant results. Give a reason for the download — it goes into the history along with your name and the date.',
          reasons: {
            CERTIFICATION_PROCESS: 'Certification work (results review, committee, appeal)',
            DEVELOPMENT_CONVERSATION: 'Development conversation with the participant',
            HR_REQUEST: 'Request from HR, the manager or the business',
            OTHER: 'Another reason',
          },
          reasonTextLabel: 'Describe the reason',
          title: 'Flashcard download',
        },
        flashcardHistory: {
          empty: 'Nobody has downloaded this participant flashcard yet.',
          reasons: {
            CERTIFICATION_PROCESS: 'Certification work',
            DEVELOPMENT_CONVERSATION: 'Development conversation',
            HR_REQUEST: 'HR or manager request',
            OTHER: 'Another reason',
          },
          summary: 'Downloads: {{count}}',
          title: 'Flashcard download history',
          unknownUser: 'Unknown user',
        },
        loading: 'Loading participants...',
        name: 'Name',
        noData: 'No participants found',
        noScore: 'No score',
        openButton: 'Open list',
        practicalExamStatistics: {
          charts: {
            perAreaTitle: 'Score and pass rate by area',
            perRegionTitle: 'Score and pass rate by region',
            perStoreTitle: 'Score and pass rate by store',
          },
          download: 'Download Excel',
          emptyFilters: 'Nobody took the exam with these filters. Change the filters to see data.',
          error: 'Could not load the statistics. Try again.',
          kpi: {
            exams: 'Exams',
            participants: 'Participants',
          },
          noData: 'No data.',
          perPersonTitle: 'Score and pass rate by person',
          series: {
            avgScore: 'Average score %',
            passRate: 'Pass rate %',
          },
          table: {
            areaColumn: '{{area}} %',
            attemptNumber: 'Attempt no.',
            chairman: 'Chairman',
            duration: 'Duration',
            examDate: 'Exam date',
            no: 'no',
            participant: 'Participant',
            passed: 'Passed',
            region: 'Region',
            result: 'Score %',
            sap: 'SAP',
            status: 'Status',
            store: 'Store',
            yes: 'yes',
          },
          title: 'Practical exam statistics',
          tooltip: {
            exams: 'Exams',
            gradedExams: 'Graded exams',
            participants: 'Participants',
          },
        },
        rowsPerPage: 'Rows per page',
        searchPlaceholder: 'Search by name or SAP number...',
        stageFilters: {
          activeCount_few: '{{count}} active',
          activeCount_many: '{{count}} active',
          activeCount_one: '{{count}} active',
          activeCount_other: '{{count}} active',
          all: 'All',
          any: 'Any',
          attempts: 'Attempts',
          close: 'Close',
          commission: 'Commission (AND)',
          commissionPlaceholder: 'Select commission members...',
          drawerTitle: 'Stage filters',
          exam: {
            hint: 'day, location (OR), commission (AND), attempts',
            title: 'Include practical exam · stage 3',
          },
          examDay: 'Exam day',
          loading: 'Loading…',
          location: 'Location (OR)',
          locationPlaceholder: 'Select locations...',
          max: 'Max',
          min: 'Min',
          no: 'No',
          passed: 'Passed',
          status: 'Status',
          survey: {
            hint: 'status, assignment, notification',
            title: 'Include survey · stage 1',
          },
          surveyAssigned: 'Survey assigned',
          surveyNotification: 'Notification sent',
          term: 'Term',
          test: {
            hint: 'term, score, attempts',
            title: 'Include knowledge test · stage 2',
          },
          testScore: 'Test score (%)',
          yes: 'Yes',
        },
        stages: 'Stages',
        status: {
          ABSENT: 'Absent',
          CANCELLED: 'Cancelled',
          COMPLETED: 'Completed',
          FAILED: 'Failed',
          IN_PROGRESS: 'In progress',
          NOT_STARTED: 'Not started',
        },
        surveyNotAssigned: 'Not assigned',
        surveyStatus: {
          COMPLETED: 'Completed',
          IN_PROGRESS: 'In progress',
          NOT_STARTED: 'Not started',
        },
        table: {
          exam: 'Practical exam',
          flashcard: 'Report',
          flashcardHistoryTooltip: 'See who downloaded this participant flashcard',
          flashcardTooltip: 'Download the individual participant report (PDF)',
          name: 'Participant',
          position: 'Position',
          region: 'Region',
          survey: 'Survey',
          test: 'Knowledge test',
        },
        teaserSubtitle: 'Survey, test and exam results',
        testStatistics: {
          charts: {
            distributionTitle: 'Answer choices by question',
            perPositionTitle: 'Average correct answers by position',
            perQuestionTitle: 'Correct answers by question',
            perRegionTitle: 'Average correct answers by region',
            perSectionTitle: 'Correct answers by area',
          },
          detailsTitle: 'Question details ({{count}})',
          download: 'Download Excel',
          emptyFilters: 'Nobody took the test with these filters. Change the filters to see data.',
          error: 'Could not load the statistics. Try again.',
          kpi: {
            executions: 'Attempts',
            participants: 'Participants',
          },
          legendNoAnswer: 'No answer',
          noData: 'No data.',
          noValue: 'none',
          questionShort: 'Q{{number}}',
          table: {
            answerKey: 'Key',
            answers: 'Answers',
            avgDuration: 'Avg. time',
            choices: 'A / B / C / D / none',
            content: 'Content',
            correctRate: '% correct',
            number: 'No.',
            section: 'Area',
          },
          title: 'Knowledge test statistics',
          tooltip: {
            attempts: 'Attempts',
            avgBestScore: 'Avg. best score',
            avgCorrectCaption: 'average correct',
            avgDuration: 'Avg. time',
            correctOf: '{{correct}} / {{answered}} correct',
            noAnswer: 'none',
            noAttempts: 'No attempts.',
            noSection: 'No area',
            participants: 'Participants',
            question: 'Question {{number}}',
            questionsInSection: 'Questions in area',
            seconds: 's',
          },
        },
        title: 'Participants',
        titleTooltip:
          "Here you'll find all participants of the certification. A participant appears on the list once they are assigned to at least one stage. Adding and removing participants is only possible through the individual stage configuration.",
      },
      stageStatusChange: {
        activateButton: 'Activate',
        activateSuccess: 'Stage activated',
        cancelButton: 'Cancel',
        cancelSuccess: 'Stage cancelled',
        completeButton: 'Complete',
        completeSuccess: 'Stage completed',
        error: 'Failed to change stage status',
        label: 'Change status',
        revertButton: 'Resume',
        revertSuccess: 'Stage resumed',
        testClosureConfirm: {
          cancelAction: 'Cancel',
          confirmAction: 'Yes, close',
          confirmCancel:
            'You are closing the entire test. All terms within this test will be cancelled. Do you want to continue?',
          confirmComplete:
            'You are closing the entire test. All terms within this test will be closed (in-progress terms will be marked as completed, not-yet-started terms will be cancelled). Do you want to continue?',
          titleCancel: 'Cancel test',
          titleComplete: 'Close test',
        },
      },
      statusChange: {
        activateButton: 'Activate',
        activateSuccess: 'Certification activated',
        cancelButton: 'Cancel',
        cancelSuccess: 'Certification cancelled',
        completeButton: 'Complete',
        completeSuccess: 'Certification completed',
        error: 'Failed to change status',
        label: 'Change status',
      },
      statusWarningsDialog: {
        activateButton: 'Activate',
        closeButton: 'Got it',
        subtitle: 'Action completed successfully. Please review the following:',
        title: 'Completed with warnings',
      },
      steps: {
        developmentCenter: {
          description: 'Development Center session results and participant reports',
          initializeButton: 'Start the Development Center stage',
          manageHint:
            'Spreadsheet uploads, report availability and the list of people live on the stage screen.',
          openStageButton: 'Open the stage',
          optionalHint:
            'The stage is optional — if the certification does not include a Development Center, simply do not start it.',
          reportsNotShared: 'Reports are not shared yet — no availability date is set.',
          reportsScheduledFrom: 'Reports sharing scheduled for {{date}}.',
          reportsSharedSince: 'Reports shared with participants since {{date}}.',
          resultsSummary: 'Overall results: {{withResults}} of {{total}} people.',
          stageActive: 'The Development Center stage is running',
          stageCreatedError: 'Could not start the Development Center stage',
          stageCreatedSuccess: 'Development Center stage started',
          stageNotInitialized: 'This certification does not include a Development Center yet',
          title: 'Development Center',
        },
        developmentPlan: {
          campaignNoName: '(campaign with no name)',
          campaignStatus: {
            [DevelopmentCycleCampaignStatusDto.Cancelled]: 'Cancelled',
            [DevelopmentCycleCampaignStatusDto.Draft]: 'Draft',
            [DevelopmentCycleCampaignStatusDto.Finished]: 'Finished',
            [DevelopmentCycleCampaignStatusDto.InProgress]: 'In progress',
          },
          coveredLabel: 'Covered',
          description:
            'The development-cycle campaign in which this certification’s participants create their development plans',
          directionLabel: 'Development direction',
          directionMissing: 'None',
          loadError: 'Could not load the stage',
          loadErrorHint: 'Try again in a moment.',
          noPermission: 'You do not have access to development-cycle campaigns',
          notStarted: 'The stage has not started',
          notStartedHint:
            'Development plans start once a campaign is created for this certification.',
          notStartedNoPermissionHint:
            'Ask a person who manages development-cycle campaigns to create one.',
          openCampaignsButton: 'Go to campaigns',
          openMembersButton: 'Covered employees',
          retryButton: 'Try again',
          tasksStartLabel: 'Tasks start',
          title: 'Development Plan',
          windowLabel: 'Cycle window',
        },
        knowledgeTest: {
          attachButton: 'Attach existing',
          attachDialog: {
            attachButton: 'Attach',
            attachError: 'Failed to attach pool',
            attachingButton: 'Attaching...',
            attachSuccess: 'Pool attached successfully',
            cancelButton: 'Cancel',
            loading: 'Loading pools...',
            noPools: 'No question pools found',
            questionCount: 'questions',
            searchPlaceholder: 'Search pools...',
            title: 'Attach Existing Pool',
          },
          browseButton: 'Browse questions',
          config: {
            backNav: 'back nav',
            notConfigured: 'Test not configured yet',
            pass: 'pass',
            questions: 'questions',
          },
          description:
            "A formal knowledge verification test assessing the participant's theoretical understanding of the certification subject. Configure question pools, schedule test terms, and manage participants to run the examination.",
          detachButton: 'Detach pool',
          detachError: 'Failed to detach pool',
          detachSuccess: 'Pool detached',
          emptyPools: 'No question pools assigned',
          initializeButton: 'Initialize',
          manageParticipantsAndTerms: 'Manage Participants & Terms',
          openConfig: 'Open Configuration',
          poolsTitle: 'Question Pools',
          stageCreatedError: 'Failed to create test stage',
          stageCreatedSuccess: 'Test stage created',
          stageNamePlaceholder: 'Stage name',
          stageNotInitialized: 'Test stage not yet initialized',
          stageParticipants: {
            addButton: 'Add Participants',
            addByEmployee: 'By Employee',
            addByPosition: 'By Position Code',
            addBySap: 'By SAP Number',
            addedHeader: 'Added',
            addError: 'Failed to add participants',
            addPositionButton: 'Add {{count}} position code(s)',
            addPositionCodesHelper:
              'Enter position codes (starting with 2 or 7) separated by commas or new lines',
            addPositionError: 'Failed to add by position',
            addPositionInvalidFormat:
              'Invalid format (must be 8 digits starting with 2 or 7): {{codes}}',
            addPositionPlaceholder: 'e.g. 20000935, 70148208',
            addSapButton: 'Add {{count}} SAP number(s)',
            addSapError: 'Failed to add by SAP number',
            addSapHelper: 'Enter SAP numbers separated by commas or new lines',
            addSapInvalidFormat: 'Invalid format (must be 8 digits): {{numbers}}',
            addSapPlaceholder: 'e.g. 12345678, 87654321',
            addSelectedButton: 'Add {{count}} participant(s)',
            addSuccess: 'Participants added to stage',
            allInStageEmpty: 'All certification participants are already in this stage',
            emailHeader: 'Email',
            filtersClear: 'Clear',
            filterStatus: 'Term status',
            filtersToggle: 'Filters',
            filterTerms: 'Filter by term',
            more: 'more',
            nameHeader: 'Participant',
            noParticipants: 'No participants yet',
            noParticipantsHint: 'Add employees from the certification participant pool above',
            noTerms: 'No terms',
            removeError: 'Failed to remove participant',
            removeSuccess: 'Participant removed from stage',
            removeTooltip: 'Remove from stage',
            searchParticipantsPlaceholder: 'Search certification participants…',
            searchPlaceholder: 'Search by name or email…',
            showing: '{{count}} of {{total}} participants',
            showLess: 'show less',
            status: {
              ASSIGNED: 'Assigned',
              EXPIRED: 'Expired',
              FAILED: 'Failed',
              PASSED: 'Passed',
              STARTED: 'In progress',
            },
            termHistoryHeader: 'Term History',
            title: 'Stage Participants',
          },
          testTerms: {
            cancelButton: 'Cancel',
            cancelledLabel: 'Cancelled',
            completeButton: 'Complete',
            completedLabel: 'Completed',
            createDialog: {
              cancelButton: 'Cancel',
              createButton: 'Create Term',
              createError: 'Failed to create test term',
              createSuccess: 'Test term created',
              creatingButton: 'Creating…',
              endHint: 'Calculated automatically from the test duration configured for this stage',
              endLabel: 'End Date & Time (computed)',
              nameLabel: 'Term Name *',
              nameMaxLength: 'Name can be at most 50 characters',
              namePlaceholder: 'e.g. June 2025 Knowledge Test',
              nameRequired: 'Term name is required',
              startLabel: 'Start Date & Time *',
              startRequired: 'Enter the start date and time',
              subtitle: 'Schedule a new test session for this stage',
              title: 'New Term',
            },
            createFirstButton: 'Create First Term',
            editDialog: {
              cancelButton: 'Cancel',
              endLabel: 'End Date & Time',
              hint: 'Start and end times are optional.',
              nameLabel: 'Term Name *',
              namePlaceholder: 'e.g. June 2025 Knowledge Test',
              nameRequired: 'Term name is required',
              saveButton: 'Save Changes',
              savingButton: 'Saving…',
              startLabel: 'Start Date & Time',
              startLockedHelper: 'Start time can only be changed for terms in "New" status.',
              subtitle: 'Update name and schedule for this test term',
              title: 'Edit Test Term',
              updateError: 'Failed to update test term',
              updateSuccess: 'Test term updated',
            },
            extendTimeButton: 'Extend time',
            extendTimeConfirm: 'Extend',
            extendTimeError: 'Failed to extend term time',
            extendTimeHint: 'Maximum allowed extension: {{max}} min',
            extendTimeLabel: 'Minutes',
            extendTimeSuccess: 'Term time extended',
            extendTimeTitle: 'Extend term time',
            hideParticipants: 'Hide participants',
            inProgressLabel: 'In Progress',
            newButton: 'New Term',
            newLabel: 'New',
            noTermsDescription: 'Create a term to schedule and manage test sessions',
            noTermsTitle: 'No test terms yet',
            participants: 'participants',
            participantsDialog: {
              activityReportError: 'Failed to download activity report',
              activityReportTooltip: 'Download activity report (PDF)',
              addButton: 'Add',
              addError: 'Failed to add participants',
              addSelectedButton: 'Add {{count}} participant(s)',
              addSuccess: 'Added {{count}} participant(s) to term',
              allInTermEmpty: 'All stage participants are already in this term',
              closeButton: 'Close',
              emailHeader: 'Email',
              noParticipants: 'No participants yet',
              noParticipantsHint: 'Add participants from the stage pool above',
              participantHeader: 'Participant',
              removeError: 'Failed to remove participant',
              removeSuccess: 'Participant removed from term',
              removeTooltip: 'Remove from term',
              searchByNameEmail: 'Search by name or email…',
              searchPlaceholder: 'Search stage participants…',
              selectLabel: 'Select from stage participants',
              statusAssigned: 'Assigned',
              statusExpired: 'Expired',
              statusFailed: 'Failed',
              statusHeader: 'Status',
              statusPassed: 'Passed',
              statusStarted: 'Started',
              subtitle: 'Term participants',
              title: 'Manage term participants',
              viewResultsTooltip: 'View results',
            },
            resultsDialog: {
              closeButton: 'Close',
              correctAnswerHeader: 'Correct Answer',
              correctLabel: 'Correct',
              executionStatus: {
                COMPLETED_FAILED: 'Failed',
                COMPLETED_PASSED: 'Passed',
                EXPIRED: 'Expired',
                IN_PROGRESS: 'In progress',
                NOT_STARTED: 'Not started',
              },
              filterAll: 'All',
              filterCorrect: 'Correct',
              filterIncorrect: 'Incorrect',
              incorrectLabel: 'Incorrect',
              noAnswerLabel: 'Not answered',
              questionHeader: 'Question',
              sectionHeader: 'Section',
              unansweredLabel: '—',
              yourAnswerHeader: 'Your Answer',
            },
            resultsListDialog: {
              closeButton: 'Close',
              correctHeader: 'Correct',
              noResults: 'No results yet',
              noResultsHint: 'Results will appear once participants complete the test',
              participantHeader: 'Participant',
              scoreHeader: 'Score',
              searchPlaceholder: 'Search by name…',
              statusHeader: 'Status',
              subtitle: '{{count}} participants',
              title: 'Term Results',
              viewDetailTooltip: 'View answers',
            },
            revertButton: 'Resume',
            revertSuccess: 'Term resumed',
            showParticipants: 'Participants ({{count}})',
            startBlockedReason: 'Assign at least one participant to this term before starting',
            startBlockedStageInactiveReason: 'Cannot start term — stage is not active',
            startButton: 'Start',
            startCertificationDraftInfo:
              'The certification is in Draft status. It will be automatically activated upon confirmation so that participants gain access.',
            startExtensionInfo:
              'Time extension is only possible while the test is in progress. Once the time runs out, the term cannot be extended.',
            startInFutureInfo:
              'The exam will be started, but participants will only be able to begin it from {{date}}.',
            startInPastInfo:
              'The scheduled start time ({{date}}) has already passed. The exam will start now.',
            startStageDraftInfo:
              "Stage '{{stageName}}' is in Draft status. It will be automatically activated upon confirmation so that participants gain access to the test.",
            title: 'Test Terms',
            updatedAt: 'Updated',
            updateError: 'Failed to update term status',
            updateSuccess: 'Term status updated',
            viewParticipantsTooltip: 'View participants',
            viewResultsTooltip: 'View results',
          },
          title: 'Knowledge Test',
          uploadButton: 'Upload Pool',
          uploadToPoolButton: 'Upload to pool',
        },
        practicalTest: {
          comingSoon: 'Coming soon',
          config: { notConfigured: 'Exam not configured yet' },
          description: 'Step description',
          examDays: 'Exam days',
          initializeButton: 'Initialize',
          openConfig: 'Open configuration',
          stageCreatedError: 'Failed to create exam stage',
          stageCreatedSuccess: 'Exam stage created',
          stageNamePlaceholder: 'Stage name...',
          stageNotInitialized: 'Practical exam stage has not been initialized.',
          title: 'Practical Test',
        },
        selfAssessment: {
          description:
            'A structured self-evaluation survey completed by the participant before the certification process begins. Helps establish a baseline and identify development gaps.',
          title: 'Self-Assessment',
        },
      },
    },
    developmentCenterStage: {
      backButton: 'Back to the certification',
      card: { edit: 'Change', hide: 'Hide' },
      certificationsTitle: 'Certifications',
      coverage: { percent: '{{percent}}%', ratio: '{{covered}} / {{total}}' },
      expectedScore: {
        error: 'Could not save the expected score. Try again.',
        fieldLabel: 'Expected score',
        hint: 'The reference point every participant score in this stage is read against. Changing it here applies to the results already uploaded.',
        label: 'Expected score',
        notSet: 'not set',
        placeholder: 'Choose a score',
        save: 'Save the score',
        saved: 'Expected score saved.',
        scaleUnavailable: 'Scale unavailable',
        valueWithScale: '{{score}} on a {{min}}-{{max}} scale',
      },
      importSummary: {
        allCovered: 'Every participant in the stage has an individual report.',
        assigned: 'newly assigned reports',
        close: 'Done',
        copied: 'Copied',
        copyFailed:
          'The browser blocked access to the clipboard. Select the list and copy it manually.',
        copyList: 'Copy the list',
        missing: 'without a report',
        missingHint: 'These {{count}} people still have no individual report:',
        rejected: 'rejected entries',
        rejectedHint:
          'Some files from the archive were not accepted. Open the details to see the reason for each one.',
        showErrors: 'View the rejected files',
        subtitle: 'What the archive brought into the stage',
        title: 'Import summary',
        unknownPerson: 'Unnamed person',
      },
      label: 'Development Center stage',
      lastImport: {
        empty: 'No spreadsheet has been uploaded yet.',
        label: 'Last import',
        meta: '{{file}} · {{date}} · {{author}}',
        problems: 'The import reported problems that still need to be resolved.',
        resolve: 'Resolve errors',
        success: 'The import finished without remarks · participants saved: {{count}}',
        unknownAuthor: 'unknown author',
        unknownFile: 'Unnamed file',
      },
      loading: 'Loading the stage…',
      notFound: 'Certification not found',
      notInitialized: 'This certification does not include a Development Center yet',
      participants: {
        columns: {
          feedback: 'DC feedback',
          name: 'Participant',
          position: 'Position',
          region: 'Region',
          removeFromStage: 'Remove',
          report: 'Report',
          results: 'Overall results',
          sapNumber: 'SAP number',
        },
        downloadReport: 'Download the individual report',
        empty: 'No people match the selected filters.',
        emptyStage: 'Nobody has been added to the stage yet.',
        enrolAll: {
          action: 'Add certification participants',
          cancel: 'Cancel',
          confirm: 'Add',
          description:
            'Every certification participant not yet on the stage will be added. People already on it are skipped.',
          result: 'Added: {{added}}. Already on the stage, skipped: {{skipped}}.',
          title: 'Add certification participants to the stage?',
        },
        feedback: {
          clearConfirm: {
            cancel: 'Cancel',
            confirm: 'Withdraw',
            description:
              'The person goes back to waiting for their feedback meeting, and the task of preparing the plan is cancelled for them.',
            title: 'Withdraw the feedback meeting?',
          },
          coverageEmpty: 'Nobody in the stage has had a feedback meeting yet.',
          coverageStatus: '{{missing}} people are still waiting for their feedback meeting.',
          coverageTitle: 'Feedback meetings after the session',
          source: { IMPORT: 'from a file', MANUAL: 'set by hand' },
          statusCompleted: 'Meeting held',
          statusMissing: 'No meeting yet',
          toggleAriaLabel: 'Feedback meeting held',
          tooltipAuthor: 'Set by: {{author}}',
          tooltipDate: 'On: {{date}}',
          tooltipSource: 'Source: {{source}}',
          unknownAuthor: 'unknown',
        },
        feedbackImport: {
          acceptedFormats: '(accepted formats: .xls, .xlsx)',
          action: 'Upload feedback file',
          cancel: 'Cancel',
          columnsHint:
            'Two columns: "nr sap" and "feedback". Write YES or NO in the feedback column. An empty cell leaves the current setting untouched.',
          columnsTitle: 'What the file needs to contain',
          dropzoneLabel: 'Drag and drop the file here, or click to choose one',
          form: { resetButton: 'Remove', uploadButton: 'Choose file' },
          submit: 'Upload the file',
          subtitle: 'Mark in bulk who has had their feedback meeting',
          summary: {
            allSaved: 'Every row from the file was saved.',
            close: 'Done',
            problemRow: 'Row {{row}} · SAP {{sap}}',
            problemRowWithoutSap: 'Row {{row}}',
            problems: 'not saved',
            problemsHint: 'These rows were not saved. The remaining ones were:',
            rowsRead: 'rows read',
            setNo: 'meeting withdrawn',
            setYes: 'meeting marked',
            skipped: 'skipped',
            subtitle: 'What the file changed in the stage',
            title: 'Feedback import summary',
            unchanged: 'no change',
          },
          title: 'Upload the feedback file',
          uploadError: 'Could not read the file. Check the columns and try again.',
        },
        filters: {
          ALL: 'Everyone',
          label: 'Missing data',
          WITHOUT_FEEDBACK: 'Without DC feedback',
          WITHOUT_REPORT: 'Without a report',
          WITHOUT_RESULTS: 'Without results',
        },
        foundCount_few: '{{count}} people found',
        foundCount_many: '{{count}} people found',
        foundCount_one: '{{count}} person found',
        foundCount_other: '{{count}} people found',
        notAssignedHint:
          'This person appeared only in the Development Center spreadsheet — they are not a participant of the remaining certification stages.',
        removeFromStage: {
          action: 'Remove from the stage',
          cancel: 'Cancel',
          confirm: 'Remove',
          description:
            'The person disappears from the stage list and stops counting towards the shortfalls. Their uploaded result and report stay untouched.',
          title: 'Remove the person from the stage?',
        },
        searchPlaceholder: 'Search by name or SAP number',
        statusMissing: 'Missing',
        statusPresent: 'Uploaded',
        totalPill: 'people {{total}}',
        unknownPerson: 'Unnamed person',
        withReportPill: 'with a report {{count}}',
        withResultsPill: 'with results {{count}}',
      },
      reports: {
        acceptedFormats: '(accepted format: .zip)',
        coverageTitle: 'Individual reports',
        dropzoneLabel: 'Drag and drop the archive here, or click to choose a file',
        form: { resetButton: 'Remove', uploadButton: 'Choose file' },
        overwriteWarning:
          'A new archive replaces the reports already in the stage. People whose report is not in the new archive lose access to the previous one.',
        overwriteWarningTitle: 'The new archive overwrites the current reports',
        replaceLabel: 'Individual reports archive',
        showWithoutReport: 'Show the missing',
        statusComplete: 'Every person in the stage has an individual report.',
        statusEmpty:
          'No report archive uploaded yet. Upload a ZIP to assign PDF reports to people.',
        statusNone: 'No date, reports unavailable',
        statusPartial: '{{missing}} people are still waiting for their report.',
        statusScheduled: 'Sharing scheduled for {{date}}',
        statusShared: 'Reports shared since {{date}}',
        transferProgress: 'Sending the archive… {{percent}}%',
        unpackingLabel: 'Unpacking the archive',
        unpackingProgress: 'Unpacking… {{percent}}%',
        unpackingStarted:
          'The archive has been sent and is being unpacked. When it finishes you will see a summary of the assigned reports.',
        uploadButton: 'Upload archive',
        uploadError: 'Could not upload the report archive',
        uploadHint:
          'A ZIP archive with the participants’ PDF reports. Until the availability date passes, nobody sees their report.',
        uploadLabel: 'Upload the report archive',
        visibilityLabel: 'Report availability',
        visibleFromClear: 'Withdraw sharing',
        visibleFromCleared: 'Date removed, participants can no longer download their reports.',
        visibleFromError: 'Could not save the availability date. Try again.',
        visibleFromField: 'Reports visible from',
        visibleFromHint:
          'One date for the whole stage. Before it, participants see the stage and the announced date but cannot download the file. Changing it after it has passed withdraws the sharing.',
        visibleFromSave: 'Save the date',
        visibleFromSaved: 'Availability date saved.',
      },
      results: {
        acceptedFormats: '(accepted formats: .xls, .xlsx)',
        coverageTitle: 'Overall results',
        downloadFile: 'Download the uploaded file',
        dropzoneLabel: 'Drag and drop the spreadsheet here, or click to choose a file',
        expectedScoreLabel: 'Expected score',
        expectedScoreMeta: 'Expected score',
        expectedScorePlaceholder: 'Choose the expected score',
        expectedScoreValueWithScale: '{{score}} on a {{min}}-{{max}} scale',
        form: { resetButton: 'Remove', uploadButton: 'Choose file' },
        historyLabel: 'Upload history',
        importMeta: '{{date}} · {{author}} · participants saved: {{count}}',
        replaceLabel: 'Results spreadsheet',
        scaleUnavailable: 'The score scale comes from the file contract and is not available yet.',
        showWithoutResults: 'Show the missing',
        statusComplete: 'Every person in the stage has their overall results.',
        statusEmpty:
          'No results spreadsheet uploaded yet. Upload one to bring in the session scores.',
        statusNoneCovered: 'A file was uploaded, but no participant has results from it yet.',
        statusPartial: '{{missing}} people are still waiting for their results.',
        unknownAuthor: 'unknown author',
        unknownFile: 'Unnamed file',
        uploadButton: 'Upload results',
        uploadError: 'Could not start the results import',
        uploadHint:
          'One supplier spreadsheet with the session results. The expected score you pick here is the reference point for every participant score in the file.',
        uploadLabel: 'Upload the results spreadsheet',
        uploadStarted:
          'The results import has started. When it finishes you will see a summary and any remarks.',
      },
      subtitle: 'Session results and participant reports',
      tabs: {
        participants: 'People in the stage',
        reports: 'Individual reports',
        results: 'Overall results',
      },
      title: 'Development Center',
      upload: { collapse: 'Hide the form', expand: 'Upload a new file' },
    },
    examStageConfig: {
      bar: {
        attemptsUnit: 'attempts',
        passPrefix: 'Pass',
        questionsUnit: 'q.',
      },
      cancelButton: 'Cancel',
      configureButton: 'Configure exam',
      confirmDialog: {
        cancel: 'Back to editing',
        confirm: 'Confirm and save',
        title: 'Configuration confirmation',
      },
      editButton: 'Edit configuration',
      fields: {
        maxAttempts: 'Max attempts',
        maxQuestions: 'Max questions',
        minQuestions: 'Min questions',
        noLimit: 'No time limit',
        ofQuestions: 'of questions',
        questionsCount: 'Number of questions',
        questionsShort: 'q.',
        requiredToPass: 'Required questions to pass',
        timeLimitMinutes: 'Time limit (min)',
      },
      notConfigured: 'Exam has not been configured yet',
      saveButton: 'Save configuration',
      validation: {
        maxAttempts: 'Must be between 1 and 10',
        maxQuestions: 'Must be ≥ min questions',
        minQuestions: 'Must be ≥ 1',
        questionsCount: 'Must be ≥ 1',
        requiredToPass: 'Must be between {{min}} and {{max}}',
      },
    },
    examStageDetail: {
      commissionMemberSearch: {
        extraMemberBadge: 'Extra member',
        loading: 'Loading…',
        noOptions: 'No people available for the commission.',
      },
      createExamDay: {
        cancelButton: 'Cancel',
        createButton: 'Create',
        fields: {
          chairman: 'Chairman',
          date: 'Date',
          hrbp: 'HRBP',
          location: 'Location',
        },
        title: 'Create exam day',
      },
      examDayDetail: {
        addParticipant: 'Add participant',
        addParticipantDialog: {
          addedEmpty: 'No participants added yet',
          addedTitle: 'Added',
          addTooltip: 'Add to exam day',
          allRegions: 'All regions',
          availableTitle: 'Available',
          clearFilters: 'Clear filters',
          close: 'Close',
          empty: 'All participants already assigned',
          noResults: 'No results for selected filters',
          regionLabel: 'Region',
          searchPlaceholder: 'Search by name or SAP number...',
          title: 'Add participants to exam day',
        },
        cancelDay: 'Cancel',
        cancelExam: 'Cancel exam',
        chairman: 'Chairman',
        columns: {
          actions: 'Actions',
          examStatus: 'Exam status',
          name: 'Name',
          result: 'Result',
        },
        completeDay: 'Complete',
        dayStatus: {
          [ExamDayStatusDto.Cancelled]: 'Cancelled',
          [ExamDayStatusDto.Completed]: 'Completed',
          [ExamDayStatusDto.Draft]: 'New',
          [ExamDayStatusDto.InProgress]: 'In progress',
        },
        examsTitle: 'Exams',
        generateExams: 'Generate exams',
        noExam: 'No exam',
        noParticipants: 'No participants assigned to this exam day',
        participants: 'Participants',
        removeParticipant: 'Remove participant',
        startDay: 'Start day',
      },
      examDays: {
        addButton: 'Add exam day',
        backToList: 'Back to list',
        cancelButton: 'Cancel',
        chairman: 'Chairman',
        completeButton: 'Complete',
        dayStatus: {
          [ExamDayStatusDto.Cancelled]: 'Cancelled',
          [ExamDayStatusDto.Completed]: 'Completed',
          [ExamDayStatusDto.Draft]: 'New',
          [ExamDayStatusDto.InProgress]: 'In progress',
        },
        empty: 'No exam days created yet',
        filters: {
          clear: 'Clear',
          commissionMember: 'Commission',
          dateFrom: 'Date from',
          dateTo: 'Date to',
          noResults: 'No results for selected filters',
          searchPlaceholder: 'Search by name or commission member...',
          toggle: 'Filters',
        },
        participantsCount: 'participants',
        startBlockedStageInactiveReason: 'Cannot start day — stage is not active',
        startButton: 'Start',
        title: 'Exam days',
        updateError: 'Failed to change exam day status',
      },
      examQuestion: {
        answerKeyLabel: 'Answer key',
        chairmanComment: 'Chairman comment',
        commentPlaceholder: 'Add comment...',
        hrbpComment: 'HRBP comment',
        questionLabel: 'Question',
        reportAreaLabel: 'Area',
        reportLabel: 'Report',
        reportShareNotSharedLabel: 'Report not shared with examinee',
        reportShareShareButton: 'Share report with examinee',
        reportShareSharedLabel: 'Report shared with examinee',
        reportShareUnshareButton: 'Unshare report',
        reportTag: 'Report',
        subquestionLabel: 'Subquestion',
        subquestionsTitle: 'Subquestions',
        verdictFail: 'Failed',
        verdictPass: 'Passed',
        verdictRejected: 'Rejected',
      },
      extraCommissionMembers: {
        addButton: 'Add person',
        addedBy: '{{date}}, {{name}}',
        columns: {
          actions: 'Actions',
          added: 'Added',
          name: 'Name',
          roles: 'Commission role',
          sapNumber: 'SAP no.',
        },
        description:
          'People from outside the reporting line who can be picked for an exam day commission. A person on the list gets access to the admin panel and to the exam days where they sit on the commission.',
        dialog: {
          add: 'Add',
          addTitle: 'Add a person to the commission',
          alreadyOnList: 'Already on the list',
          cancel: 'Cancel',
          editTitle: 'Change commission roles',
          loading: 'Loading…',
          noOptions: 'No people match the search.',
          personLabel: 'Person',
          rolesLabel: 'Can be picked as',
          rolesRequired: 'Select at least one role.',
          save: 'Save',
          saveError: 'The changes could not be saved. Try again.',
          searchPlaceholder: 'Search by name, email or SAP number',
        },
        editTooltip: 'Change commission roles',
        empty:
          'Nobody is on the list yet. Add a person if someone from outside the reporting line should sit on the commission.',
        loadError: 'The list could not be loaded. Refresh the page to try again.',
        removeDialog: {
          cancel: 'Cancel',
          confirm: 'Remove',
          conflict:
            'This person sits on the commission of an exam day that has not finished yet. Change the commission of that day first.',
          description:
            'This person will no longer be available when picking an exam day commission.',
          error: 'The person could not be removed from the list. Try again.',
          title: 'Remove the person from the list?',
        },
        removeTooltip: 'Remove from the list',
        roles: {
          [CommissionCandidateRoleDto.Chairman]: 'Chairman',
          [CommissionCandidateRoleDto.Hrbp]: 'HRBP',
        },
        title: 'Extra commission members',
      },
      individualExam: {
        cancelButton: 'Cancel exam',
        carriedOver: {
          close: 'Close',
          modalTitle: 'Source exam day',
          previewSourceTooltip: 'Preview source exam day',
          question: 'Question',
          report: 'Report',
          subtitle:
            'Areas marked as "global pass" already passed on another exam day. They are not graded again, but they do count towards this exam\'s result and pass threshold.',
          title: 'Passed in previous exam days',
        },
        chairmanComment: 'Chairman comment',
        changelog: 'Changelog',
        createdAt: 'Created',
        dayNotStarted: 'start exam day first',
        dayNotStartedDialogCancel: 'Cancel',
        dayNotStartedDialogConfirm: 'Start day and exam',
        dayNotStartedDialogMessage:
          'The exam day has not been started yet. To start the exam, the exam day must be started first.',
        dayNotStartedDialogTitle: 'Exam day not started',
        editModeOff: 'Disable comment editing',
        editModeOn: 'Edit comments',
        examStatus: {
          [IndividualExamStatusDto.Cancelled]: 'Cancelled',
          [IndividualExamStatusDto.Draft]: 'Draft',
          [IndividualExamStatusDto.Failed]: 'Failed',
          [IndividualExamStatusDto.Passed]: 'Passed',
          [IndividualExamStatusDto.Started]: 'In progress',
        },
        failed: 'Failed',
        finishButton: 'Finish exam',
        finishedAtLabel: 'Finished',
        generalComment: 'General comments',
        generalCommentPlaceholder: 'Add general comment about the exam...',
        generalCommentVisibilityNotice: 'These comments will be visible to the examinee',
        hrbpComment: 'HRBP comment',
        infoAssignedQuestions: 'Assigned questions',
        infoMinQuestions: 'Min. required',
        infoQuestionsShort: 'q.',
        infoRequiredToPass: 'Required to pass',
        infoTimeLimit: 'Time limit',
        minRequired: 'min {{min}}, graded {{current}}',
        notPassing: 'not passing',
        passed: 'Passed',
        passing: 'passing',
        progress: 'Progress',
        questionsTitle: 'Questions',
        result: 'Result',
        resultFailed: 'EXAM FAILED',
        resultPassed: 'EXAM PASSED',
        stage2AttemptsCount_few: '{{count}} attempts',
        stage2AttemptsCount_many: '{{count}} attempts',
        stage2AttemptsCount_one: '{{count}} attempt',
        stage2AttemptsCount_other: '{{count}} attempts',
        stage2Failed: 'failed',
        stage2NotAvailable: 'Theoretical test not completed',
        stage2NoTerms: 'Participant was not assigned to any term',
        stage2Passed: 'passed',
        stage2Result: 'Stage 2 — Theoretical test',
        stage2Status: {
          ABSENT: 'Absent',
          COMPLETED: 'Passed',
          FAILED: 'Failed',
          IN_PROGRESS: 'In progress',
          NOT_STARTED: 'Not started',
        },
        stage2TermsListTitle: 'Theoretical test — attempts',
        stage2ViewAttemptsTooltip: 'View all attempts',
        stage2ViewTooltip: 'View theoretical test answers',
        startButton: 'Start exam',
        startedAtLabel: 'Started',
        total: 'Total',
      },
      label: 'Practical exam stage',
      loading: 'Loading exam stage...',
      notInitialized:
        'Practical exam stage has not been initialized. Initialize it from the certification detail page.',
      participants: {
        add: 'Add',
        addButton: 'Add participant',
        addByEmployee: 'From certification',
        addByPosition: 'By position',
        addBySap: 'By SAP',
        addedNoneNotFound: 'None of the SAP numbers were found: {{identifiers}}',
        addedNoneTestNotPassed:
          'No one was added — none of the listed employees has passed the test (stage 2).',
        addedSummaryWithSkipped:
          'Added {{added}} participant(s); skipped {{skipped}} without a passed test (stage 2).',
        addedSummaryWithSkippedSap:
          'Added {{added}} participant(s); skipped {{skipped}}: {{identifiers}}',
        addFromCertification: 'Add from certification participants',
        addPositionButton: 'Add {{count}} position(s)',
        addPositionCodesHelper:
          'Enter position codes separated by commas or spaces (format: 2xxxxxxx or 7xxxxxxx)',
        addPositionError: 'Error adding participants by position',
        addPositionInvalidFormat: 'Invalid format: {{codes}}',
        addPositionPlaceholder: 'e.g. 20000001, 70000002',
        addSapButton: 'Add {{count}} SAP number(s)',
        addSapError: 'Error adding participants by SAP',
        addSapHelper: 'Enter SAP numbers separated by commas or spaces (8-digit number)',
        addSapInvalidFormat: 'Invalid format: {{numbers}}',
        addSapPlaceholder: 'e.g. 00012345, 00067890',
        addSelectedButton: 'Add {{count}} participant(s)',
        addSuccess: 'Participants added successfully',
        columns: {
          actions: 'Actions',
          addedAt: 'Added at',
          email: 'Email',
          examStatus: 'Exam status',
          name: 'Name',
        },
        empty: 'No participants added yet',
        filtersClear: 'Clear',
        filtersToggle: 'Filters',
        helpTooltip:
          'Only employees who passed the test (stage 2) within this certification can be added to the practical exam stage (stage 3).',
        noAvailableParticipants: 'All certification participants already added',
        noEligibleParticipants:
          'No eligible participants — none of the employees in this certification has passed the test (stage 2) yet.',
        removeTooltip: 'Remove participant',
        searchPlaceholder: 'Search participants...',
        title: 'Participants',
      },
      practicalAttempts: {
        abandonButton: 'Abandon',
        abandonTooltip: 'Mark as abandoned',
        attemptChip: 'Attempt {{number}} · {{status}}',
        attemptsUsed: 'Attempts used: {{used}}/{{max}}',
        completeButton: 'Complete',
        completeTooltip: 'Mark as completed',
        detail: {
          answerKey: 'Answer key',
          emptyAttempt: 'This attempt contains no questions or reports',
          linkCopied: 'Link copied to clipboard',
          noAttachments: 'No attachments',
          pdfPreviewError: 'Failed to load PDF preview',
          pdfPreviewLoading: 'Loading preview…',
          pdfPreviewPager: 'Page {{page}} / {{total}}',
          questions: 'Questions ({{count}})',
          reports: 'Reports ({{count}})',
          shareButton: 'Share',
          shareError: 'Could not create share link',
          title: 'Attempt {{number}} details',
        },
        limitReached: 'Attempts limit reached',
        maxAttempts: 'Limit: {{count}} attempts',
        noParticipants: 'No participants registered for the practical exam',
        passed: 'Passed',
        startButton: 'Start attempt',
        startError: 'Could not start attempt',
        startSuccess: 'Attempt started',
        status: {
          [PracticalExamAttemptStatusDto.Abandoned]: 'Abandoned',
          [PracticalExamAttemptStatusDto.Completed]: 'Completed',
          [PracticalExamAttemptStatusDto.InProgress]: 'In progress',
        },
        statusUpdateError: 'Could not update status',
        statusUpdateSuccess: 'Status updated',
        title: 'Commission attempts',
      },
      questionPools: {
        attachButton: 'Attach pool',
        browseTooltip: 'Browse questions',
        detachError: 'Failed to detach pool',
        detachSuccess: 'Pool detached',
        detachTooltip: 'Detach pool',
        empty: 'No question pools attached yet. Upload or attach an existing pool.',
        poolCount: 'Pools:',
        questionsCount: 'Questions:',
        title: 'Question Pools',
        uploadButton: 'Upload pool',
        uploadToPoolTooltip: 'Add questions to pool',
      },
      questions: {
        addButton: 'Add question',
        cancelButton: 'Cancel',
        columns: {
          actions: 'Actions',
          answerKey: 'Answer key',
          question: 'Question',
        },
        empty: 'No questions added yet',
        fields: {
          answerKey: 'Answer key',
          questionText: 'Question text',
        },
        generateSample: 'Generate sample (5)',
        removeTooltip: 'Delete question',
        saveButton: 'Add',
        searchPlaceholder: 'Search questions...',
        title: 'Questions',
      },
      tabs: {
        attempts: 'Attempts',
        config: 'Configuration',
        examDays: 'Exam days',
        examDaysLockedReason:
          'Upload questions, configure the stage and assign at least one participant to continue',
        participants: 'Participants',
        questions: 'Questions',
      },
      title: 'Practical Test',
    },
    examStageStatus: {
      [ExamStageStatusDto.Completed]: 'Completed',
      [ExamStageStatusDto.InProgress]: 'In Progress',
      [ExamStageStatusDto.NotInitialized]: 'Not Initialized',
      [ExamStageStatusDto.NotStarted]: 'Not Started',
    },
    filters: {
      allStatuses: 'All statuses',
      searchButton: 'Search',
      searchPlaceholder: 'Search by name...',
      status: 'Status',
    },
    formDialog: {
      cancelButton: 'Cancel',
      clearDeadline: 'Clear deadline',
      createButton: 'Create',
      createError: 'Failed to create certification',
      createSuccess: 'Certification created successfully',
      createTitle: 'Create Certification',
      deadlineHelp: 'Optional completion deadline',
      deadlineLabel: 'Deadline',
      deadlinePastConfirm: 'The selected deadline is in the past. Are you sure you want to set it?',
      deadlinePastWarning: 'Deadline is in the past',
      deadlineValidation: 'Deadline must be today or in the future',
      description: 'Description',
      descriptionMaxLength: 'Description can be up to 200 characters',
      editTitle: 'Edit Certification',
      nameLabel: 'Name *',
      nameMaxLength: 'Name can be up to 50 characters',
      nameRequired: 'Name is required',
      saveButton: 'Save Changes',
      savingButton: 'Saving...',
      status: 'Status',
      updateError: 'Failed to update certification',
      updateSuccess: 'Certification updated successfully',
    },
    itemRow: {
      createdAt: 'Created',
      deleteDisabledTooltip: 'Can only delete DRAFT certifications',
      deleteTooltip: 'Delete',
      openTooltip: 'Open',
    },
    loadError: 'Failed to load certifications',
    loading: 'Loading certifications...',
    newButton: 'New Certification',
    practicalExam: {
      attachDialog: {
        attachButton: 'Attach',
        attachError: 'Failed to attach pool',
        attachingButton: 'Attaching...',
        attachSuccess: 'Pool attached',
        cancelButton: 'Cancel',
        noPools: 'No practical exam pools found',
        questionCount: 'questions',
        searchButton: 'Search',
        searchPlaceholder: 'Search pools...',
        title: 'Attach practical exam pool',
      },
      poolCard: {
        detachButton: 'Detach pool',
        questionsLabel: 'questions',
        showQuestions: 'Show {{count}} questions',
        uploadToPoolButton: 'Add questions to pool',
      },
      questionsBrowser: {
        addAttachmentButton: 'Add PDF',
        answerKeyLabel: 'Answer key',
        areaAll: 'All areas',
        attachmentDeleteError: 'Failed to delete attachment',
        attachmentDeleteSuccess: 'Attachment deleted',
        attachmentsLabel: 'Attachments',
        deleteAttachment: 'Delete attachment',
        downloadAttachment: 'Download',
        globalPassLabel: 'Globally passed',
        globalPassTooltip: 'If enabled, this question/report will not reappear in retake attempts',
        noAttachments: 'No attachments yet',
        noQuestions: 'No simple questions',
        noReports: 'No reports',
        previewAttachment: 'Preview',
        previewCloseButton: 'Close',
        questionsSection: 'Simple questions',
        reportChipLabel: 'REPORT',
        reportsSection: 'Reports',
        searchPlaceholder: 'Search by content or answer key...',
        subquestionsLabel: 'Subquestions',
      },
      reportAttachmentDialog: {
        cancelButton: 'Cancel',
        chooseFileButton: 'Choose PDF',
        dragDropText: 'Drag & drop or click to select a PDF file',
        errorToast: 'Upload failed',
        fileLabel: 'PDF file *',
        fileRequired: 'File is required',
        fileTooLarge: 'File is too large (max 10 MB)',
        hint: 'PDF only, max 10 MB.',
        invalidFileType: 'Only PDF files are allowed',
        successToast: 'Attachment uploaded',
        title: 'Add attachment to report "{{area}}"',
        uploadButton: 'Upload',
        uploadingButton: 'Uploading...',
      },
      richKeyEditor: {
        uploadError: "Couldn't upload {{filename}}. Try again.",
        uploading: 'Uploading {{filename}}…',
      },
      uploadPoolDialog: {
        appendTitle: 'Upload to practical exam stage',
        cancelButton: 'Cancel',
        chooseFileButton: 'Choose file',
        dragDropText: 'Drag & drop or click to select .xlsx file',
        errorToast: 'Upload failed',
        fileLabel: 'File (XLSX) *',
        fileRequired: 'File is required',
        formatColumns:
          'One sheet per area (OiW/Pieczywo/Lada): Section | Subcategory | Scored (TAK/NIE). "Raporty" sheet: Report name | Section | Subcategory | Scored.',
        formatTitle: 'Expected format (multi-sheet)',
        formatTypes:
          '"_Globalne zaliczenie" sheet: Area | Global pass. Answer keys and PDF files are filled in the app after upload.',
        nameHelp: 'Optional pool name (defaults to "Pula pytań egzaminu praktycznego")',
        nameLabel: 'Pool name',
        successToast: 'Pool uploaded successfully',
        title: 'Upload practical exam question pool',
        uploadButton: 'Upload',
        uploadingButton: 'Uploading...',
        validationErrorsTitle: 'Validation errors',
      },
      uploadToExistingPoolDialog: {
        cancelButton: 'Cancel',
        chooseFileButton: 'Choose file',
        dragDropText: 'Drag & drop or click to select .xlsx file',
        errorToast: 'Upload failed',
        fileLabel: 'File (XLSX) *',
        fileRequired: 'File is required',
        successToast: 'Questions added successfully',
        title: 'Add practical exam questions to "{{poolName}}"',
        uploadButton: 'Upload',
        uploadingButton: 'Uploading...',
        validationErrorsTitle: 'Validation errors',
      },
    },
    questionPools: {
      filters: {
        allTypes: 'All types',
        search: 'Search',
        searchPlaceholder: 'Search by name...',
      },
      table: {
        actions: 'Actions',
        browseButton: 'Browse questions',
        createdAt: 'Created',
        name: 'Name',
        noData: 'No question pools found',
        questionCount: 'Questions',
        rowsPerPage: 'Rows per page',
        type: 'Type',
        uploadButton: 'Upload Pool',
      },
      title: 'Question Pools',
    },
    questionsBrowser: {
      explanationLabel: 'Explanation',
      noResults: 'No questions found',
      questionCount: 'questions',
      rankLabel: 'Rank',
      searchPlaceholder: 'Search questions...',
      sectionPlaceholder: 'Filter by section',
      singleChoiceLabel: 'Single choice',
      tabPool: 'This pool',
      tabStage: 'All pools',
      title: 'Browse Questions',
      typeAll: 'All types',
      typeRank: 'Rank',
      typeSingleChoice: 'Single choice',
    },
    status: {
      [CertificationStatusDto.Active]: 'Active',
      [CertificationStatusDto.Cancelled]: 'Cancelled',
      [CertificationStatusDto.Completed]: 'Completed',
      [CertificationStatusDto.Draft]: 'Draft',
    },
    stepCard: {
      configured: 'Configured',
      instructionsTooltip: 'Show admin instructions',
      notConfigured: 'Not configured',
      stepLabel: 'Step',
    },
    stepLabels: {
      comingSoon: 'coming soon',
      developmentCenter: 'Development Center',
      devPlan: 'Dev Plan',
      knowledgeTest: 'Knowledge Test',
      notConfigured: 'Not configured',
      participants: '{{count}} participants',
      practicalTest: 'Practical Test',
      selfAssessment: 'Self-Assessment',
    },
    summary: {
      active: 'Active',
      completed: 'Completed',
      draft: 'Draft',
      total: 'Total',
    },
    surveyStep: {
      activationDialog: {
        cancel: 'Cancel',
        confirm: 'Activate & start',
        description:
          'For participants to receive survey notifications, the following statuses must be active. Activate them now and start the survey?',
        error: 'Failed to activate statuses',
        itemCertification: 'Certification — will be activated',
        itemStage: 'Stage 1 (Self-Assessment) — will be activated',
        success: 'Statuses activated and survey started',
        title: 'Activation required',
      },
      assignExisting: 'Assign existing',
      changeButton: 'Change',
      changeSurveyTooltip: 'Change survey',
      createNew: 'Create new',
      deadlineLabel: 'Deadline',
      deadlinePastTooltip: 'Deadline has passed — consider changing status to Completed.',
      detachButton: 'Detach',
      detachSurveyTooltip: 'Detach survey',
      noParticipants: 'No participants',
      noSurveyDescription: 'Assign an existing survey or create a new one for this certification.',
      noSurveyTitle: 'No survey assigned',
      participants: 'participants',
      startDisabledTooltip: 'Add participants to start the survey',
      status: {
        ACTIVE: 'Active',
        CANCELLED: 'Cancelled',
        COMPLETED: 'Completed',
        DRAFT: 'Draft',
      },
      statusAction: {
        cancel: 'Cancel',
        complete: 'Complete',
        start: 'Start',
      },
    },
    table: {
      actions: 'Actions',
      createdBy: 'Created by',
      deadline: 'Deadline',
      name: 'Name',
      noData: 'No certifications found',
      status: 'Status',
      steps: 'Steps',
    },
    testStageConfig: {
      activateBlockedReason: 'Create at least one test term to activate this stage',
      bar: {
        passPrefix: 'Pass',
        questionsUnit: 'q.',
        resultVisibilityWindow: 'Questions visible {{minutes}} min after end',
      },
      cancelButton: 'Cancel',
      configureButton: 'Configure test',
      editButton: 'Edit configuration',
      fields: {
        allowBackNavigation: 'Back navigation',
        backNavEnabled: 'Back nav enabled',
        noLimit: 'No limit',
        numberOfQuestions: 'Questions',
        passingThreshold: 'Pass threshold (%)',
        resultVisibility: 'Result visibility',
        resultVisibilityWindowMinutes: 'Questions visibility window (min)',
        resultVisibilityWindowMinutesHint: 'After this only the score remains',
        timeExtensionHint: 'Max. {{max}} min',
        timeExtensionMinutes: 'Time extension (min)',
        timeLimitMinutes: 'Time limit (min)',
      },
      label: 'Test Configuration',
      notConfigured: 'Test not configured yet',
      pools: {
        attachButton: 'Attach existing',
        attachError: 'Failed to detach pool',
        browseButton: 'Browse questions',
        detachBlockedByActiveTerm:
          'Cannot detach pool — the stage has an active term (NEW or IN_PROGRESS). Cancel or finish all active terms first.',
        detachButton: 'Detach',
        detachError: 'Failed to detach pool',
        none: 'No question pools attached',
        poolCount: 'Pools:',
        poolQuestionCount: 'Questions:',
        questionsLabel: 'questions',
        title: 'Question Pools',
        uploadButton: 'Upload new',
        uploadToPoolButton: 'Upload more questions',
      },
      resultVisibilityOptions: {
        none: 'None (results not shared)',
        resultOnly: 'Result only (pass/fail)',
        resultWithQuestions: 'Result + questions with error marking',
        resultWithScore: 'Result + percentage score',
      },
      saveButton: 'Save config',
      saveError: 'Failed to save configuration',
      saveSuccess: 'Configuration saved',
      sections: {
        available: 'Available: {{count}} questions',
        exceedsAvailable: 'Max {{count}} available',
        none: 'No section distribution configured',
        title: 'Section distribution',
        total: 'Total: {{total}} questions',
        totalLabel: 'Total questions',
      },
    },
    testStageDetail: {
      backButton: 'Back to Certification',
      label: 'Knowledge Test Stage',
      loading: 'Loading test stage...',
      notFound: 'Test stage not found',
      notInitialized:
        'Test stage not initialized. Initialize it from the certification detail first.',
      subtitle: 'Stage Management — Participants & Test Terms',
      tabs: {
        config: 'Test Configuration',
        configLockedReason: 'Upload a question pool first to unlock the configuration',
        participants: 'Stage Participants',
        participantsLockedReason: 'Save the test configuration first',
        pools: 'Question Pools',
        terms: 'Test Terms',
        termsLockedReason:
          'Configure the stage and assign at least one participant to the stage to continue',
      },
      title: 'Knowledge Test',
    },
    title: 'Certifications',
    uploadPoolDialog: {
      appendTitle: 'Upload to Existing Stage',
      cancelButton: 'Cancel',
      chooseFileButton: 'Choose file',
      dragDropText: 'Drag & drop or click to select .xlsx file',
      errorToast: 'Upload failed',
      fileLabel: 'File (XLSX) *',
      fileRequired: 'File is required',
      nameHelp: 'Optional name (defaults to sheet name)',
      nameLabel: 'Pool name',
      successToast: 'Pool uploaded successfully',
      title: 'Upload Question Pool',
      uploadButton: 'Upload',
      uploadingButton: 'Uploading...',
      validationErrorsTitle: 'Validation errors',
    },
    uploadToExistingPoolDialog: {
      cancelButton: 'Cancel',
      chooseFileButton: 'Choose file',
      dragDropText: 'Drag & drop or click to select .xlsx file',
      errorToast: 'Upload failed',
      fileLabel: 'File (XLSX) *',
      fileRequired: 'File is required',
      successToast: 'Questions added successfully',
      title: 'Add questions to "{{poolName}}"',
      uploadButton: 'Upload',
      uploadingButton: 'Uploading...',
      validationErrorsTitle: 'Validation errors',
    },
  },
  changeHistory: {
    filters: {
      action: 'Action',
      actions: {
        activate: 'Activate',
        assign: 'Assign',
        create: 'Create',
        deactivate: 'Deactivate',
        delete: 'Delete',
        toggleOverride: 'Toggle Override',
        unassign: 'Unassign',
        update: 'Update',
      },
      all: 'All',
      changedAfter: 'Changed After',
      changedBefore: 'Changed Before',
      changedByUserEmail: 'Changed By',
      changeType: 'Change Type',
      changeTypes: {
        permissionEdit: 'Permission Edit',
        roleEdit: 'Role Edit',
        rolePermissionAssignment: 'Role Permission Assignment',
        userPermissionChange: 'User Permission Change',
        userRoleChange: 'User Role Change',
      },
      clearFilters: 'Clear Filters',
      targetUserEmail: 'Target User',
    },
    table: {
      actions: {
        ACTIVATE: 'Activate',
        ASSIGN: 'Assign',
        CREATE: 'Create',
        DEACTIVATE: 'Deactivate',
        DELETE: 'Delete',
        TOGGLE_OVERRIDE: 'Toggle Override',
        UNASSIGN: 'Unassign',
        UPDATE: 'Update',
      },
      changeTypes: {
        PERMISSION_EDIT: 'Permission Edit',
        ROLE_EDIT: 'Role Edit',
        ROLE_PERMISSION_ASSIGNMENT: 'Role Permission Assignment',
        USER_PERMISSION_CHANGE: 'User Permission Change',
        USER_ROLE_CHANGE: 'User Role Change',
      },
      error: 'Error loading data',
      fieldName: 'Field',
      headers: {
        action: 'Action',
        changedAt: 'Changed At',
        changedBy: 'Changed By',
        changeType: 'Change Type',
        description: 'Description',
        id: 'ID',
        permission: 'Permission',
        role: 'Role',
        targetUser: 'Target User',
      },
      loading: 'Loading change history...',
      newValue: 'New Value',
      noData: 'No data to display',
      oldValue: 'Old Value',
      rowsPerPage: 'Rows per page',
    },
  },
  confirmPermissionAction: {
    actions: {
      activatePermission: {
        description:
          'Activating the permission will make it available in the system and assignable to roles and users.',
        title: 'Are you sure you want to activate this permission?',
        warning: '',
      },
      addIndividualPermission: {
        description:
          'Adding an individual permission will grant the user this permission regardless of assigned roles.',
        title: 'Are you sure you want to add this individual permission?',
        warning:
          'Individual permissions are granted directly to the user and are not managed through roles.',
      },
      addRoleToUser: {
        description: 'Adding the role will grant the user all permissions assigned to this role.',
        title: 'Are you sure you want to add this role?',
        warning: '',
      },
      assignPermissionToRole: {
        description:
          'Assigning a permission to the role will grant it to all users with this role.',
        title: 'Are you sure you want to assign this permission to the role?',
        warning: 'This change will affect all users assigned to this role.',
      },
      deactivatePermission: {
        description:
          'Deactivating the permission will make it unavailable in the system and it will no longer be assignable.',
        title: 'Are you sure you want to deactivate this permission?',
        warning:
          'The permission will remain assigned to existing roles and users but will be inactive.',
      },
      deactivateRolePermission: {
        description:
          'Deactivating the permission from the role will remove it for this user from this role, but they may still have it from other sources.',
        title: 'Are you sure you want to deactivate this permission?',
        warning:
          'This does not remove the permission from the role, it only disables it for this specific user.',
      },
      removeIndividualPermission: {
        description:
          'Removing the individual permission will revoke it from the user (unless they have it from an assigned role).',
        title: 'Are you sure you want to remove this individual permission?',
        warning: '',
      },
      removePermissionFromRole: {
        description:
          'Removing a permission from the role will revoke it from all users with this role.',
        title: 'Are you sure you want to remove this permission from the role?',
        warning: 'This change will affect all users assigned to this role.',
      },
      removeRoleFromUser: {
        description:
          'Removing the role will revoke all permissions assigned to this role from the user.',
        title: 'Are you sure you want to remove this role?',
        warning: 'System roles cannot be removed, they can only be deactivated.',
      },
      toggleRole: {
        description:
          'Changing the role status will enable/disable all permissions from this role for this user.',
        title: 'Are you sure you want to change this role status?',
        warning: 'Applies to system roles only.',
      },
    },
    cancel: 'Cancel',
    confirm: 'Confirm',
  },
  dictionaries: {
    editDialog: {
      active: 'Active',
      cancel: 'Cancel',
      englishName: 'English Name',
      polishName: 'Polish Name',
      save: 'Save',
      saving: 'Saving...',
      title: 'Edit Dictionary Entry',
    },
    filters: {
      active: 'Active',
      allStatuses: 'All statuses',
      allTypes: 'All Types',
      inactive: 'Inactive',
      name: 'Name',
      searchByName: 'Search by name',
      status: 'Status',
      type: 'Type',
    },
    table: {
      actions: 'Actions',
      code: 'Code',
      edit: 'Edit',
      englishName: 'English Name',
      noData: 'No data matching the selected filters is available',
      noFilters: 'Please select a dictionary type first to view data',
      polishName: 'Polish Name',
      rowsPerPage: 'Rows per page',
      status: {
        false: 'Inactive',
        true: 'Active',
      },
      statusHeader: 'Status',
      type: 'Type',
    },
    title: 'Dictionaries',
  },
  employeesList: {
    buttons: {
      export: 'Export to Excel',
    },
    content: {
      table: {
        active: 'Active',
        email: 'Email',
        externalEmployeeId: 'SAP ID',
        firstName: 'First Name',
        inactive: 'Inactive',
        lastName: 'Last Name',
        openProfile: 'Open employee profile',
        openProfileUnavailable: 'No permission to view this profile',
      },
    },
    dialog: {
      activateInfo:
        "Activation restores the system roles that follow from this person's HR data (Employee, P1/P2 Manager, HRBP).",
      cancel: 'Cancel',
      confirm: 'Confirm',
      deactivateInfo:
        "Deactivation revokes this person's system roles (Employee, P1/P2 Manager, HRBP) along with the access they grant. Manually assigned roles, such as Administrator, stay untouched.",
      message: 'Are you sure you want to change the active status of this employee?',
      title: 'Confirm Status Change',
    },
    form: {
      externalEmployeeId: 'SAP ID',
      firstName: 'First Name',
      lastName: 'Last Name',
    },
  },
  groups: {
    certification: 'Certification',
    content: 'Content',
    management: 'Management',
    tools: 'Tools',
  },
  impersonation: {
    blockedDisabled: 'This account is inactive, so you cannot switch to it.',
    blockedNoRole: 'This person has no role assigned, so you cannot switch to them.',
    blockedPrivileged:
      'This person holds administrative permissions (roles management or session switching), so you cannot switch to them.',
    noEmployeeRecordChip: 'no employee record',
    noRoleChip: 'no role',
    privilegedChip: 'administrative permissions',
  },
  legalDocuments: {
    currentBadge: 'in force',
    delete: 'Delete version',
    deleteDialog: {
      cancel: 'Cancel',
      confirm: 'Delete',
      message: 'This version will be permanently deleted along with its file.',
      title: 'Delete this version?',
    },
    dropzoneHintPrefix: 'PDF file, up to',
    dropzoneLabel: 'Drag the new terms here or choose a file',
    dropzoneMaxSize: '8 MB',
    empty: 'No version has been published yet. Upload a PDF to make the terms available to users.',
    info: 'The newly published version immediately replaces the previous one under the same link in the application footer. Earlier versions stay here and can be restored.',
    preview: 'Open the file',
    setCurrent: 'Set as the version in force',
    versionLabel: 'Version {{version}}',
    versionsTitle: 'Published versions',
  },
  news: {
    actions: {
      archive: 'Archive',
      backToDraft: 'Move to draft',
      cancel: 'Cancel',
      delete: 'Remove',
      edit: 'Edit',
      error: 'Could not update news status. Try again.',
      preview: 'Preview',
      publish: 'Publish',
    },
    categories: {
      [NewsCategoryDto.Business]: 'Development',
      [NewsCategoryDto.System]: 'jAIn updates',
      [NewsCategoryDto.Tutorials]: 'Tutorials',
    },
    confirmations: {
      archive: {
        confirm: 'Archive',
        message: 'This article will be archived and removed from the landing page news feed.',
        title: 'Archive news',
      },
      delete: {
        confirm: 'Remove',
        message:
          'Are you sure you want to permanently remove this article? This action cannot be undone.',
        title: 'Remove news',
      },
      draft: {
        confirm: 'Move to draft',
        message: 'This article will stop being visible in published news lists.',
        title: 'Move news to draft',
      },
      publish: {
        confirm: 'Publish',
        message: 'This article will become visible in the landing page news feed.',
        title: 'Publish news',
      },
    },
    editor: {
      cancel: 'Cancel',
      categoryLabel: 'Category',
      categoryRequired: 'Category is required',
      changeImage: 'Change image',
      chooseImage: 'Choose image',
      contentHelp: '',
      contentLabel: 'Content',
      createError: 'Could not create news item.',
      createTitle: 'Create new publication',
      editTitle: 'Edit publication',
      imageClear: 'Clear',
      imageDropActive: 'Drop the image here',
      imageDropReplace: 'Drop or click to replace image',
      imageDropSubtitle: 'Accepted formats: JPEG, PNG, WebP',
      imageDropTitle: 'Drag and drop an image or click to choose',
      imageHelp:
        'Optional. JPEG, PNG or WebP, up to 10 MB. The image is inserted into article content after saving.',
      imageLabel: 'In-text image',
      imageSelected: 'Selected images:',
      imageSizeError: 'Image can be up to 10 MB.',
      imageTypeError: 'Use JPEG, PNG or WebP image.',
      loading: 'Loading article...',
      publishNow: 'Publish now',
      save: 'Save',
      saveChanges: 'Save changes',
      saveDraft: 'Save as draft',
      saving: 'Saving...',
      subtitle: 'Prepare the article content and publish it when ready.',
      titleLabel: 'Title',
      titleMaxLength: 'Title can have up to 180 characters',
      titlePlaceholder: 'e.g. New reporting rules...',
      titleRequired: 'Title is required',
      toolbar: {
        bold: 'Bold',
        image: 'Insert image',
        italic: 'Italic',
        link: 'Paste link URL',
        linkDialog: {
          apply: 'Apply link',
          cancel: 'Cancel',
          title: 'Insert link',
        },
        orderedList: 'Numbered list',
        underline: 'Underline',
        unorderedList: 'Bulleted list',
        video: 'Insert video (supported formats: MP4, WebM)',
      },
      untitledDraft: 'Untitled draft',
      updateError: 'Could not update news item.',
      videoError:
        'This video cannot be played. The file may be damaged or temporarily unavailable.',
      videoProcessing:
        'The video has been uploaded and is being processed. It will appear on its own once processing finishes — no need to upload it again.',
      videoProcessingFailed:
        'Processing of this video failed. Remove it from the content and upload the file again.',
      videoTypeError: 'Use MP4 or WebM video. QuickTime/MOV is not supported in Firefox.',
    },
    empty: {
      title: 'No news found',
    },
    filters: {
      allCategories: 'All categories',
      allStatuses: 'All statuses',
      category: 'Category',
      searchPlaceholder: 'Search news by title...',
      status: 'Status',
    },
    newButton: 'New article',
    preview: {
      close: 'Close',
      emptyContent: 'No content has been added yet.',
      subtitle: 'See how the news is seen by employees on the landing page.',
      title: 'News preview',
      videoError: 'This video cannot be played. The file may be damaged or encoded incorrectly.',
    },
    statuses: {
      [NewsStatusDto.Archived]: 'Archived',
      [NewsStatusDto.Draft]: 'Draft',
      [NewsStatusDto.Published]: 'Published',
    },
    subtitle: 'Create, edit, publish and archive articles.',
    table: {
      actions: 'Actions',
      category: 'Category',
      createdAt: 'Created',
      error: 'Error loading news',
      loading: 'Loading news...',
      noData: 'No news matches the current filters.',
      noImage: 'No image',
      publishedAt: 'Published',
      rowsPerPage: 'Rows per page',
      status: 'Status',
      title: 'Title',
      updatedAt: 'Updated',
    },
    title: 'News management',
  },
  noPermissions: 'You do not have permissions to access any section of the admin panel.',
  permissionDetails: {
    active: 'Active',
    category: 'Category',
    code: 'Code',
    description: 'Description',
    inactive: 'Inactive',
    name: 'Name',
    noDescription: 'No description',
    status: 'Permission status',
    title: 'Permission details',
  },
  permissionsEmployees: {
    backToList: 'Back to list',
    columns: {
      department: 'Department',
      email: 'Email',
      employee: 'Employee',
      sap: 'SAP',
      status: 'Status',
    },
    description: 'Search for an employee to manage their roles and permissions.',
    detail: {
      activate: 'Activate',
      allWithCount: 'All ({{count}})',
      assignedPermissions: 'Assigned permissions',
      assignedRoles: 'Assigned roles ({{count}})',
      availablePermissions: 'Available permissions',
      availableRoles: 'Available roles ({{count}})',
      categoryNone: 'None',
      categoryUncategorized: 'Uncategorized',
      deactivate: 'Deactivate',
      fromRole: 'from role: {{role}}',
      hrbpTitle: 'Unit / position permissions',
      individualPermissions: 'Individual permissions',
      noAssignedPermissions: 'No assigned permissions',
      noAssignedRoles: 'No assigned roles',
      noAvailablePermissions: 'No available permissions',
      noAvailableRoles: 'No available roles',
      noPermissionsMatch: 'No permissions match the criteria.',
      noResults: 'No results',
      noRolePermissions: 'No permissions from roles.',
      permissionCount: 'Permission count: {{count}}',
      permissionsTitle: 'Permissions',
      roleDisableSuffix: 'disable',
      roleEnableSuffix: 'enable',
      rolePermissions: 'Permissions from roles',
      rolesTitle: 'Employee roles',
      searchByNameOrCode: 'Search by name or code',
      statusActive: 'Active',
      statusDisabled: 'Disabled',
      systemBadge: 'SYSTEM',
      systemRolesInfoBody:
        'System roles are assigned automatically and cannot be removed. They can only be enabled/disabled for a specific employee.',
      systemRolesInfoTitle: 'System roles',
      toast: {
        bulkPartial: 'Updated {{success}} of {{total}} permissions. Check the console for details.',
        cannotRemoveSystemRole: 'System role cannot be removed. You can only deactivate it.',
        individualsAdded: 'Individual permissions added',
        individualsAddError: 'Failed to add individual permissions',
        individualsRemoved: 'Individual permissions removed',
        individualsRemoveError: 'Failed to remove individual permissions',
        noRolesSelected: 'No roles selected for update',
        permissionActivated: 'Permission "{{name}}" has been activated',
        permissionActivatedForRoles:
          'Permission "{{name}}" has been activated for roles: {{roles}}',
        permissionDeactivated: 'Permission "{{name}}" has been deactivated',
        permissionDeactivatedForRoles:
          'Permission "{{name}}" has been deactivated for roles: {{roles}}',
        permissionUpdateError: 'Failed to update permission',
        roleAdded: 'Role "{{name}}" has been added',
        roleAddError: 'Failed to add role to user',
        roleDisabled: 'Role "{{name}}" has been disabled',
        roleEnabled: 'Role "{{name}}" has been enabled',
        roleNotFoundForPermission: 'No role found for this permission',
        rolePermissionUpdateError: 'Failed to update permission from roles',
        roleRemoved: 'Role has been removed',
        roleRemoveError: 'Failed to remove role from user',
        roleUpdateError: 'Failed to update user role',
      },
    },
    emptyResultsDescription: 'No employees found matching the given criteria.',
    emptyResultsTitle: 'No results',
    loading: 'Loading employees...',
    onlyModified: 'Only modified',
    rowsPerPage: 'Per page:',
    searchPlaceholder: 'Search by SAP, first name, last name, email...',
    startDescription: 'Type a search term or enable the filter to display employees.',
    startTitle: 'Start searching',
    statusModified: 'Modified',
    title: 'Employees — Roles and Permissions',
  },
  permissionsTable: {
    active: 'Active',
    allCategories: 'All categories',
    columnActions: 'Actions',
    columnCategory: 'Category',
    columnCode: 'Code',
    columnDescription: 'Description',
    columnName: 'Name',
    columnStatus: 'Status',
    count: '{{filtered}} of {{total}} permissions',
    deleteCentralInfo: 'Deleting permission "{{code}}" is managed centrally.',
    editCentralInfo: 'Editing permission "{{code}}" is available only in the system panel.',
    emptyDescription: 'No permissions have been defined in the system yet.',
    emptyFilteredDescription: 'No permissions match the given criteria. Try changing the filters.',
    emptyFilteredTitle: 'No results',
    emptyTitle: 'No permissions',
    inactive: 'Inactive',
    loading: 'Loading permissions...',
    searchPlaceholder: 'Code, name or description...',
    toggleError: 'Failed to update the permission',
    toggleSuccess: 'Permission status updated',
  },
  professionalActivityDefinitions: {
    documents: {
      aiContext: 'AI context',
      aiContextTooltip:
        'When on, the document feeds the AI assistant for assigned employees. Off = download only.',
      deleteDialog: {
        cancel: 'Cancel',
        confirm: 'Delete',
        message: 'This file will be permanently deleted. This action cannot be undone.',
        title: 'Delete document',
      },
      dropzoneHintPrefix: 'or drag and drop a file here.',
      dropzoneLabel: 'Click to upload a file',
      dropzoneMaxSize: 'Max size: 20 MB',
      embeddingStatus: {
        available: '✓ Available in AI',
        failed: 'Processing failed',
        noContent: 'No content',
        notEmbedded: 'Not processed',
        processing: 'Processing...',
      },
      empty: 'No documents attached yet',
      loading: 'Loading documents...',
      reembed: 'Re-process',
      title: 'Documents',
    },
    editDialog: {
      cancel: 'Cancel',
      description: 'Description',
      developmentProgram: 'Development program',
      editYear: 'Edition year',
      name: 'Name',
      save: 'Save',
      saving: 'Saving...',
      status: 'Status',
      statusValues: {
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In progress',
        PLANNED: 'Planned',
      },
      title: 'Edit professional activity definition',
    },
    searchPlaceholder: 'Search by name',
    table: {
      description: 'Description',
      developmentProgram: 'Development program',
      editYear: 'Edition year',
      name: 'Name',
      noData: 'No professional activity definitions found',
      rowsPerPage: 'Rows per page',
      status: 'Status',
      statusValues: {
        COMPLETED: 'Completed',
        IN_PROGRESS: 'In progress',
        PLANNED: 'Planned',
      },
      updatedAt: 'Updated',
    },
    title: 'Development Activities',
  },
  ragDocuments: {
    form: {
      fields: {
        categories: {
          label: 'Categories',
          placeholder: 'Select categories',
        },
        description: {
          label: 'Description',
        },
        file: {
          accepted: 'Accepted formats: PDF, DOCX (max 10MB)',
          dropzoneLabel: 'Drag and drop a file here, or click to select',
          remove: 'Remove',
        },
        tags: {
          label: 'Tags',
          placeholder: 'Type a tag and press Enter',
        },
        title: {
          label: 'Title',
        },
      },
      status: {
        awaitingValidationResolution: 'Awaiting validation resolution',
        close: 'Close',
        error: 'Upload failed',
        finished: 'Upload completed',
        inProgress: 'Processing',
        notStarted: 'Initializing upload',
        processing: 'Processing document...',
        readingDocument: 'Reading document',
        validationFailed: 'Validation failed',
      },
      submitButton: 'Upload document',
      submitButtonLoading: 'Uploading...',
      title: 'Upload new document',
      toasts: {
        initError: 'Failed to initiate document upload',
        sseError: 'Lost connection to the upload progress server',
        uploadError: 'Failed to upload the document',
        uploadSuccess: 'Document has been uploaded.',
      },
    },
  },
  roleAssignments: {
    allWithCount: 'All ({{count}})',
    assignAriaLabel: 'Assign selected permissions',
    assignedTitle: 'Assigned permissions – {{role}}',
    assignError: 'Failed to add permissions to the role',
    assignSuccess: 'Permissions added to the role',
    availableTitle: 'Available permissions',
    categoryWithCount: '{{category}} ({{count}})',
    confirmDetails: 'Permissions: {{count}}\nRole: {{role}}',
    count: '{{filtered}} of {{total}} permissions',
    emptyAssigned: 'No permissions assigned to this role.',
    emptyAvailable: 'No permissions available to assign.',
    emptyFiltered: 'No permissions match the filter criteria.',
    noRoles: 'No roles available.',
    removeAriaLabel: 'Remove selected permissions',
    removeError: 'Failed to remove permissions from the role',
    removeSuccess: 'Permissions removed from the role',
    rolePlaceholder: '---',
    rolesTitle: 'Roles',
    searchPlaceholder: 'Search by name or code',
    selectAll: 'Select all',
    selectedCount: 'Selected: {{count}}',
  },
  roleForm: {
    cancel: 'Cancel',
    colorHint: 'Color used in cards and charts.',
    colorLabel: 'Color',
    createTitle: 'New role',
    descriptionLabel: 'Role description',
    editTitle: 'Edit role',
    nameLabel: 'Role name',
    save: 'Save',
  },
  roles: {
    badgePermissions: '{{count}} permissions',
    badgePermissionsSystem: '{{count}} permissions • system role',
    count: '{{count}} roles',
    emptyDescription: 'No roles found in the system.',
    emptySearchDescription:
      'No roles found matching "{{search}}". Try changing your search criteria.',
    emptySearchTitle: 'No search results',
    emptyTitle: 'No roles',
    loading: 'Loading roles...',
    searchPlaceholder: 'Search roles',
    updateError: 'Failed to update the role',
    updateSuccess: 'Role updated',
  },
  sections: {
    accounts: {
      description: 'Search, verify and manage system account access.',
    },
    data: {
      historyDescription: 'Review import status, validation errors and recent upload activity.',
      historyTitle: 'Upload history',
      uploadDescription: 'Upload employee, organizational and system data files from one panel.',
      uploadTitle: 'Upload data',
    },
    developmentCycles: {
      applyToAllChip: 'Applies to everyone',
      campaignStatus: {
        [DevelopmentCycleCampaignStatusDto.Cancelled]: 'Cancelled',
        [DevelopmentCycleCampaignStatusDto.Draft]: 'Draft',
        [DevelopmentCycleCampaignStatusDto.Finished]: 'Finished',
        [DevelopmentCycleCampaignStatusDto.InProgress]: 'In progress',
      },
      campaignType: {
        CERTIFICATION: 'Certification',
        DEFAULT: 'Standard',
        MDR: 'MDR',
      },
      cancelCampaign: {
        cancel: 'Cancel',
        confirm: 'Cancel campaign',
        description:
          'Cancel the campaign “{{name}}”? All of its development plans (completed ones included) move to history and their open tasks are cancelled.',
        notice:
          'Cancelling is not the same as finishing. Finishing closes every plan on its own merit, depending on the steps ticked off, while cancelling archives them all. Either way the employees are no longer covered by the campaign. A historical plan can be restored once the employee is covered by this campaign again.',
        title: 'Cancel campaign',
      },
      delete: {
        cancel: 'Cancel',
        confirm: 'Delete campaign',
        description: 'Delete the campaign "{{name}}"? This action cannot be undone.',
        title: 'Delete campaign',
      },
      description:
        'Development-cycle campaigns: window, task start date and covered employees. Several campaigns can be active, but an employee belongs to exactly one.',
      fields: {
        certification: 'Linked certification',
        certificationFallback: 'Open certification',
        covered: 'Covered employee SAP numbers',
        coveredAll: 'Everyone not covered by another campaign. This campaign creates no tasks.',
        coveredEmpty: 'Empty list — the campaign covers nobody, so no tasks will be created.',
        developmentDirection: 'Development direction',
        name: 'Name',
        noName: '(no name)',
        tasksStartDate: 'Tasks created from',
        window: 'Cycle window',
      },
      filters: {
        anyStatus: 'Any status',
        anyType: 'Any type',
        searchPlaceholder: 'Campaign name or SAP number',
        statusLabel: 'Status',
        typeLabel: 'Type',
      },
      form: {
        applyToAll: 'Apply to everyone',
        applyToAllHint:
          'The campaign covers everyone no other campaign covers. Only one such campaign can be in progress.',
        applyToAllNotice:
          'A catch-all campaign creates no tasks — it only opens self-service plan creation. Tasks come only from campaigns with a list of employees.',
        campaignType: 'Campaign type',
        campaignTypeHint: {
          CERTIFICATION:
            'Every participant gets the same development direction, and the direction field disappears from the plan form. You can point the campaign at the certification its participants came from.',
          DEFAULT: 'A campaign with no extra restrictions — works as before.',
          MDR: 'Covers only people in the MDR process (with the 7-field matrix filled in). SAP numbers are checked as they are added.',
        },
        campaignTypeOption: {
          CERTIFICATION: 'Certification campaign',
          DEFAULT: 'Standard campaign',
          MDR: 'MDR campaign',
        },
        cancel: 'Cancel',
        certification: 'Linked certification',
        certificationEmpty: 'No certification matches the search.',
        certificationHint:
          'Optional. It lets you jump from the campaign straight to the certification its participants came from.',
        certificationPlaceholder: 'Start typing a certification name',
        createTitle: 'New campaign',
        cycleValidFrom: 'Cycle valid from',
        cycleValidTo: 'Cycle valid to',
        developmentDirection: 'Development direction',
        developmentDirectionHint:
          'Shared by every participant of the campaign. The employee does not enter their own — the plan form shows this direction as set by the administrator.',
        developmentDirectionPlaceholder: 'e.g. Shift Manager',
        editTitle: 'Edit campaign',
        errors: {
          conflict:
            'Check the campaign dates and whether the SAP numbers already belong to another active campaign.',
          developmentDirection: 'A certification campaign requires a development direction.',
          generic: 'Could not save the campaign.',
          tasksStartDate: 'The task start date must fall inside the cycle window.',
          window: 'The "valid to" date must be later than "valid from".',
        },
        name: 'Campaign name',
        namePlaceholder: 'Optional, e.g. Cycle 2026 H1',
        sapCheck: {
          accepted: 'The campaign takes {{acceptedCount}} of {{total}} numbers.',
          button: 'Check the numbers',
          checking: 'Checking...',
          copied: 'Copied',
          copyFailed: 'Could not copy the list. Select it and copy it by hand.',
          copyRejected: 'Copy the turned-down numbers',
          error: 'Could not check the numbers. Try again.',
          reason: {
            ALREADY_IN_OTHER_CAMPAIGN: 'already covered by another running campaign',
            NOT_IN_MDR_PROCESS: 'not in the MDR process',
            UNKNOWN_SAP: 'no employee with this number',
          },
          rejectedRow: '{{sap}} — {{reason}}',
          rejectedTitle: 'Turned down: {{rejectedCount}}',
        },
        sapImport: {
          clearConfirmAction: 'Clear',
          clearConfirmBody:
            'This removes {{sapCount}} numbers from the list. The action cannot be undone.',
          clearConfirmTitle: 'Clear the whole list?',
          clearList: 'Clear list',
          dropzoneBottom: 'Supported format: XLSX',
          dropzoneTop: 'Drag an XLSX file here, or click to choose one',
          errorTooMany:
            'The file holds more than 10,000 SAP numbers. Split it into smaller files and import again.',
          errorUnreadable: 'Could not read the file. Make sure it is a valid XLSX file.',
          fileHint:
            'One number per row, in the first column. Numbers must match HR data exactly. If they start with a zero, format the Excel column as text.',
          modeAppend: 'Append to list',
          modeBody:
            'The list already holds {{existingCount}} numbers and the file holds {{incomingCount}}. Append them to the current list, or replace it?',
          modeCancel: 'Cancel',
          modeReplace: 'Replace list',
          modeTitle: 'SAP numbers loaded from file',
          rejectedRow: 'row {{row}}: {{value}}',
          rejectedTitle: 'Rejected entries ({{rejectedCount}})',
          showAll: '+{{hiddenCount}} — show all',
          showLess: 'Collapse list',
          summaryDuplicates: 'Duplicates skipped: {{duplicateCount}}.',
          summarySuccess: 'Loaded {{addedCount}} numbers from file {{fileName}}.',
        },
        save: 'Save',
        status: 'Campaign status',
        statusHint: {
          [DevelopmentCycleCampaignStatusDto.Cancelled]:
            'The campaign is cancelled. Its plans sit in history and its employees are back under the catch-all campaign.',
          [DevelopmentCycleCampaignStatusDto.Draft]:
            'The campaign is being prepared. It covers nobody and creates no tasks, so another draft may hold the same SAP numbers.',
          [DevelopmentCycleCampaignStatusDto.Finished]:
            'The campaign is finished. Plans with every step ticked off are closed as completed, the rest went to the historical ones. No new tasks are created.',
          [DevelopmentCycleCampaignStatusDto.InProgress]:
            'The campaign covers employees and creates tasks. A SAP number may belong to only one such campaign.',
        },
        statusOption: {
          [DevelopmentCycleCampaignStatusDto.Cancelled]: 'Cancelled',
          [DevelopmentCycleCampaignStatusDto.Draft]: 'Draft',
          [DevelopmentCycleCampaignStatusDto.Finished]: 'Finished',
          [DevelopmentCycleCampaignStatusDto.InProgress]: 'In progress',
        },
        targetSaps: 'Covered employee SAP numbers',
        targetSapsAdd: 'Add',
        targetSapsEmpty: 'Empty list — the campaign covers nobody and creates no tasks.',
        targetSapsHint:
          'Employees on this list are expected to build a plan in this campaign. Their P1 supervisor gets the direction-setting task, which hands over to the employee after 7 days.',
        targetSapsPlaceholder: 'e.g. 10023',
        tasksStartDate: 'Task start date',
      },
      impact: {
        activation:
          'Starting this campaign creates direction-setting tasks for the P1 supervisors of the covered employees and sends notifications. A catch-all campaign creates no tasks at all. Other running campaigns are left untouched. Continue?',
        activeEdit:
          'Saving changes to a running campaign cancels the open pre-plan tasks and recreates them from the new list of employees. The 7-day supervisor deadlines restart and notifications are sent again. Continue?',
        cancel: 'Cancel',
        confirm: 'Continue',
        finish:
          'Finishing this campaign closes its participants’ plans and creates no further tasks. A plan with every step ticked off is closed as completed, while a plan with unfinished steps goes to the historical ones and does not pass the development-plan stage of the linked certification. This cannot be undone. Continue?',
        title: 'Confirm the consequences',
        withdrawal:
          'The campaign stops covering employees. Open pre-plan tasks are cancelled and creating a plan is possible only if a catch-all campaign picks them up. Existing plans and their tasks stay unchanged. Continue?',
      },
      members: {
        back: 'Back to campaigns',
        detail: {
          back: 'Back to the list',
          cycleCampaign: 'Campaign',
          cycleDirection: 'Direction',
          cycleState: 'State',
          cycleWindow: 'Window',
          noAccount: 'No account',
          noPlans: 'This employee has no development plan yet.',
          noPlansTitle: 'No plans',
          noTaskReason: 'No-task reason',
          noTasks: 'No tasks tied to this employee’s plans.',
          noTasksTitle: 'No tasks',
          p1: 'P1 supervisor',
          pageDescription: 'Full view of one employee’s plans and tasks.',
          pageTitle: 'Employee detail',
          plansTitle: 'Development plans',
          taskDeadline: 'Deadline',
          taskDescription: 'Description',
          taskStatus: 'Status',
          tasksTitle: 'Plan tasks',
          taskTarget: 'Target',
          taskTrigger: 'Type',
          thisCampaign: 'This campaign',
        },
        emptyDescription: 'No employee matches the selected filters.',
        emptyTitle: 'No employees',
        error: 'Could not load the covered employees.',
        errorTitle: 'Error',
        filters: {
          anyPlanStatus: 'Any plan status',
          planStatusLabel: 'Plan status',
          searchPlaceholder: 'Search by name or SAP',
          withoutAccount: 'No user account',
          withoutTask: 'No task',
        },
        no: 'No',
        pageDescription:
          'Employees covered by the campaign, with plan status, task and the reason a task is missing.',
        pageTitle: 'Covered employees',
        planStatus: {
          ARCHIVED: 'Historical',
          CANCELLED: 'Cancelled',
          COMPLETED: 'Completed',
          DRAFT: 'Draft',
          NONE: 'No plan',
          READY_FOR_REALIZATION: 'Ready',
          SUPERVISOR_APPROVED: 'Approved',
          SUPERVISOR_REJECTED: 'Rejected',
        },
        reason: {
          BEFORE_TASKS_START: 'Before the campaign task start',
          CAMPAIGN_NOT_IN_PROGRESS: 'The campaign is not in progress',
          CATCH_ALL: 'Catch-all campaign — creates no tasks',
          NO_USER_ACCOUNT: 'No user account',
          PENDING_SCAN: 'Waiting for the next scan',
          PLAN_EXISTS: 'Plan already exists',
        },
        source: {
          APPLY_TO_ALL: 'Catch-all campaign',
          TARGETED: 'From the list',
        },
        summary: {
          covered: 'Covered',
          withOpenTask: 'With task',
          withPlan: 'With plan',
          withUserAccount: 'With account',
        },
        table: {
          account: 'Account',
          name: 'Employee',
          p1: 'P1 supervisor',
          plan: 'Plan status',
          source: 'Source',
          task: 'Task / reason',
        },
        taskType: {
          PLAN_INITIATION: 'Initiation (P1)',
          PLAN_REQUIRED: 'Create plan',
        },
        yes: 'Yes',
      },
      noCampaignInProgress:
        'No campaign is in progress — nobody is covered, so plan creation is disabled and no tasks are generated.',
      sweep: {
        button: 'Run task creation now',
        description:
          'Runs on demand exactly what the scheduler does daily at 06:15: it creates direction-setting tasks for the supervisors of covered employees, and with no campaign it sweeps away lingering tasks.',
        result: 'Done — created tasks: {{created}}, cancelled lingering: {{cancelled}}.',
        testBadge: 'test tool',
        title: 'Task scheduler',
      },
      table: {
        actions: 'Actions',
        campaignType: 'Type',
        cancelAction: 'Cancel campaign',
        covered: 'Covered',
        coveredAll: 'everyone',
        coveredEmpty: 'nobody',
        createButton: 'New campaign',
        deleteAction: 'Delete',
        downloadPlansAction: 'Download the development plans of covered employees',
        downloadPlansColumn: 'Plans',
        editAction: 'Edit',
        empty: 'No development-cycle campaign has been configured yet.',
        emptyFiltered: 'No campaign matches the filters. Change them or clear the search.',
        emptyFilteredTitle: 'Nothing matches the filters',
        emptyTitle: 'No campaigns',
        finishAction: 'Finish',
        members: 'Members',
        membersAction: 'Show covered employees',
        name: 'Name',
        startAction: 'Start',
        status: 'Status',
        tasksStartDate: 'Task start',
        title: 'All campaigns',
        window: 'Cycle window',
      },
    },
    employees: {
      description: 'Find employees and manage their active status in the organization.',
    },
    legalDocuments: {
      description: 'Publish the terms of use that users can open from the application footer.',
    },
    permissions: {
      description: 'Manage roles, permissions and user access across the system.',
    },
  },
  sidebar: {
    backToStart: 'Back to start',
    collapseAriaLabelCollapsed: 'Expand admin menu',
    collapseAriaLabelExpanded: 'Collapse admin menu',
    subtitle: 'Administration sections',
  },
  structureBrowser: {
    axis: {
      hrbp: 'By HR business partner',
      label: 'Group by',
      supervisor: 'By line manager',
    },
    backToList: 'Back to the list',
    columns: {
      department: 'Department',
      name: 'Person',
      peopleCount: 'People with an account',
      position: 'Position',
      roles: 'Roles',
      sapNumber: 'SAP number',
    },
    description: {
      accounts:
        'Only people with an active account and at least one role are listed, so the numbers can be lower than in Structure.',
      scopeHrbp: 'The count covers the people assigned directly to that person.',
      scopeSupervisor: 'The count covers everyone below a person, not only their direct reports.',
    },
    empty: {
      noPeople: 'Nobody here has an active account.',
      noSupervisors: 'Nobody here has anyone with an active account assigned.',
    },
    team: {
      title: 'People of {{name}}',
      total: 'People: {{total}}',
    },
    title: 'Structure browser',
  },
  successionPermissions: {
    comingSoon: 'Coming Soon',
    description: 'Succession permissions management will be available here.',
    errors: {
      loadingData: 'Error loading data:',
      loadingUnits: 'Error loading units:',
    },
    loading: {
      data: 'Loading data...',
      units: 'Loading units...',
    },
    messages: {
      hrbpHqInfo: 'Only users with the HRBP HQ role are visible here.',
      noDataForSelectedUnits: 'No data to display for selected units.',
      saving: 'Saving...',
      selectUnits: 'Select organizational units to display HRBP permissions.',
    },
    table: {
      headers: {
        employeeCount: 'Employee Count',
        unitPosition: 'Unit / Position',
      },
    },
    unitSelection: {
      allButton: 'All',
      clearAllButton: 'Clear all',
      label: 'Select units',
      moreChipLabel: 'more',
      placeholder: 'Select organizational units',
      remainingUnitsTooltip: 'Remaining units',
    },
  },
  surveyDetail: {
    backButton: 'Back',
    backToCertification: 'Back to Certification',
    backToSurveys: 'Back to Surveys',
    createdAt: 'Created',
    createdBy: 'Author',
    deadline: 'Deadline',
    editButton: 'Edit',
    label: 'Survey',
    overview: {
      areas: 'Areas',
      categories: 'Categories',
      categoryLink: 'Links',
      closedQuestions: 'Closed',
      negative: 'Negative',
      noCategoriesFound: 'No categories found',
      openQuestions: 'Open',
      positive: 'Positive',
      procedureDescription: 'Procedure description',
      procedureName: 'Procedure',
      questions: 'Questions',
      scale: 'Rating Scale',
      searchCategories: 'Search categories...',
      selectCategoryPrompt: 'Select a category to see details',
      threshold: 'threshold',
      total: 'Total',
    },
    participants: {
      actions: 'Actions',
      answers: {
        allAreas: 'All Areas',
        allCategories: 'All Categories',
        answer: 'Answer',
        answerDuration: 'Duration: {{duration}}',
        areaFilter: 'Area',
        categoryFilter: 'Category',
        error: 'Error loading answers',
        loading: 'Loading answers...',
        noData: 'No answers found',
        questionNumber: 'Question {{number}}',
        report: {
          downloadButton: 'Download Excel report',
          downloading: 'Downloading...',
          error: 'Error downloading report',
          reportType: {
            EMPLOYEE_SURVEY_ANSWERS: 'Employee survey answers',
          },
          subtitle: 'Download a full Excel report with answers and categories below threshold.',
          title: 'Answers report',
        },
        rowsPerPage: 'Rows per page',
        searchPlaceholder: 'Search in questions or answers...',
        summary: {
          allCategoriesMet: 'There are no areas requiring improvement.',
          categoriesCount: 'Below you will find areas that need improvement',
          competencyWorkRequired: 'Competency work required',
          goToResources: 'Go to resources',
          greatJob: 'Great job!',
          howToImprove: 'What to do to increase your knowledge?',
          loading: 'Loading summary...',
          procedureDescription: 'Procedure description',
          procedureName: 'Procedure',
          questionNumber: 'Question {{number}}:',
          supportMaterials: 'Support materials:',
          viewAnswers: 'View answers',
        },
        tabAnswers: 'Participant Answers',
        tabReport: 'Answers Report',
        tabSummary: 'Employee Survey Summary',
        title: 'Participant Answers',
        totalAnswers: 'Total answers: {{count}}',
      },
      assignedAt: 'Assigned',
      completedAt: 'Completed',
      dates: 'Dates',
      details: 'Details',
      email: 'Email',
      hasSurveyAssigned: 'Survey Assigned',
      name: 'Name',
      notificationSent: 'Notification Sent',
      position: 'Position',
      search: 'Search',
      startedAt: 'Started',
      status: {
        all: 'All',
        null: 'N/A',
        [SurveyAssignmentStatusDto.Cancelled]: 'Cancelled',
        [SurveyAssignmentStatusDto.Completed]: 'Completed',
        [SurveyAssignmentStatusDto.InProgress]: 'In Progress',
        [SurveyAssignmentStatusDto.Pending]: 'Pending',
      },
      statusLabel: 'Status',
      table: {
        actions: 'Actions',
        error: 'Error loading participants',
        loading: 'Loading participants...',
        noData: 'No participants',
        rowsPerPage: 'Rows per page',
      },
      viewAnswers: 'View Answers',
    },
    questions: {
      all: 'All',
      area: 'Area',
      assignedTo: 'Assigned to',
      category: 'Category',
      categoryDetails: 'Category details',
      categoryLink: 'Open link',
      employee: 'Employee',
      filters: 'Filter',
      group: 'Group',
      position: 'Position',
      procedureDescription: 'Procedure description',
      procedureName: 'Procedure',
      total: 'Total',
      type_CLOSED: 'Closed',
      type_OPEN: 'Open',
    },
    reports: {
      download: 'Download',
      downloading: 'Downloading...',
      error: 'Error downloading report',
      reportType: {
        EMPLOYEE_SURVEY_ANSWERS: 'Employee survey answers',
      },
      subtitle: 'Download reports for all survey participants.',
    },
    status: 'Status',
    statusAction: {
      cancel: 'Cancel Survey',
      complete: 'Complete',
      start: 'Start',
    },
    statusUpdateError: 'Failed to update status',
    statusUpdateSuccess: 'Status updated',
    tabs: {
      overview: 'Overview',
      participants: 'Participants',
      questions: 'Questions',
      reports: 'Reports',
    },
  },
  surveys: {
    addButton: 'Add Survey',
    dialog: {
      cancel: 'Cancel',
      deadline: 'Deadline',
      deadlineHelp: 'Optional survey deadline date',
      dragDropText: 'or drag and drop here',
      file: 'Excel File',
      fileHelp: 'File should contain sheets: Questions, Scales, Categories',
      name: 'Survey Name',
      save: 'Save',
      saving: 'Uploading...',
      title: 'Add New Survey',
      uploadSuccess: 'Survey uploaded successfully',
    },
    editDialog: {
      cancel: 'Cancel',
      deadline: 'Deadline',
      deadlineHelp: 'Optional survey deadline date',
      deadlineMustBeFuture: 'Deadline must be in the future',
      name: 'Survey Name',
      nameMaxLength: 'Name can be at most 50 characters',
      nameRequired: 'Survey name is required',
      save: 'Save',
      saving: 'Saving...',
      status: 'Status',
      statusLocked: 'The status of a cancelled survey cannot be changed.',
      title: 'Edit Survey',
      updateError: 'Your changes could not be saved. Try again.',
      updateSuccess: 'Survey updated successfully',
    },
    filters: {
      search: 'Search',
    },
    status: {
      ACTIVE: 'Active',
      CANCELLED: 'Cancelled',
      COMPLETED: 'Completed',
      DRAFT: 'Draft',
    },
    statusUpdateError: 'Error updating status',
    statusUpdateSuccess: 'Survey status updated successfully',
    table: {
      actions: 'Actions',
      author: 'Author',
      createdAt: 'Created',
      deadline: 'Deadline',
      details: 'Details',
      edit: 'Edit',
      error: 'Error loading surveys',
      loading: 'Loading surveys...',
      name: 'Name',
      noData: 'No surveys available',
      participants: 'Participants',
      report: 'Report',
      rowsPerPage: 'Rows per page',
      status: 'Status',
    },
    title: 'Manage Surveys',
  },
  tabs: {
    accountsManagement: 'Accounts',
    certificationSubTabs: {
      certification: 'Certifications',
      questionPools: 'Question Pools',
      surveys: 'Surveys',
    },
    changeHistory: 'Change History',
    dataManagement: 'Data',
    dataManagementUpload: 'Upload Data',
    developmentCycles: 'Development cycles',
    devPlanTester: 'Development plan tester',
    dictionaries: 'Dictionaries',
    employeesManagement: 'Employees',
    impersonation: 'Switch user',
    legalDocuments: 'Legal documents',
    news: 'News',
    permissions: 'Roles & Permissions',
    permissionSubTabs: {
      assignments: 'Assignments',
      employees: 'Employees',
      hrbpPermissions: 'HRBP HQ Permissions',
      permissions: 'Permissions',
      roles: 'Roles',
    },
    professionalActivityDefinitions: 'Development Activities',
    ragDocuments: 'Chat Documents',
    structureBrowser: 'Structure browser',
    successionPermissions: 'Succession Permissions',
    surveys: 'Certification',
    taskCreator: 'Task creator (dev)',
  },
  taskCreator: {
    creating: 'Creating...',
    deadline: 'Deadline',
    description: 'Description',
    error: 'Could not create task.',
    resourceType: {
      [ResourceTypeDto.App]: 'Application',
      [ResourceTypeDto.DevelopmentPath]: 'Development path',
      [ResourceTypeDto.Employee]: 'Employee',
      [ResourceTypeDto.Survey]: 'Survey',
    },
    sourceResourceType: 'Source type',
    sourceResourceValue: 'Source value',
    submit: 'Create task',
    subtitle: 'Testing helper. Assignee is the current user; employee target uses SAP ID.',
    targetResourceType: 'Target type',
    targetResourceValue: 'Target value (SAP / external ID)',
    title: 'Task creator',
  },
  title: 'Admin Panel',
};
